export default Object.freeze({
    A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS:`Samanniminen asettelu on jo olemassa`,
    ACCEPT:`Hyväksy`,
    ACCEPT_ALL:`Hyväksy kaikki`,
    ACCEPT_REJECT_TRANSFER_PENDING: `Hyväksyntä odottaa`,
    ACCEPTED: `Hyväksytty`,
    ACCOUNT:`Tili`,
    ACCOUNT_ADDRESS:`Tilin osoite`,
    ACCOUNT_COUNTRY:`Tilin maa`,
    ACCOUNT_END: `Tilin loppu`,
    ACCOUNT_NAME:`Tilin nimi`,
    ACCOUNT_NUMBER:`Tilinumero`,
    ACCOUNT_NUMBER_REQUIRED:`Tilin numero vaaditaan`,
    ACCOUNTS:`Tilit`,
    ACCUMULATED_DAYS_ON_RENT:`Kertyneet päivät vuokralla`,
    ACCUMULATED_DAYS_RENTED:`Kertyneet vuokrauspäivät`,
    ACTIONS:`Toiminnot`,
    ACTIVE_WARRANTY:`Aktiivinen takuu`,
    ACTIVE_WARRANTY_CLICK_FOR_DETAIL:`Aktiivinen takuu (saat lisätietoja napsauttamalla)`,
    ACTIVE_WARRANTY_Y_N: `Aktiivinen takuu (K/E)`,
    ACTUAL_AMOUNT_OF_USE:`Todellinen käyttömäärä`,
    ACTUAL_AUDIT:`Todellinen tarkastus`,
    ACTUAL_AUDIT_DATE:`Todellinen kirjauspäivämäärä`,
    ACTUAL_COURIER_NAME:`Todellinen kuriirin nimi`,
    ACTUAL_H:`Todelliset tunnit`,
    ACTUAL_HOURS:`Todelliset tunnit`,
    ACTUAL_PC:`Todelliset paalit`,
    ADD_CLAIM:`Lisää anomus`,
    ADD_CLAIMS:`Lisää anomuksia`,
    ADD_COMPONENT:`Lisää komponentti`,
    ADD_OPTION:`Lisää asetus`,
    ADD_REP:`Lisäkorjaus`,
    ADD_TO_AUDIT:`Lisää valvontaan`,
    ADDITIONAL:`Lisätiedot`,
    ADDITIONAL_COMMENTS:`Lisäkommentit`,
    ADDITIONAL_REPAIR:`Lisäkorjaus`,
    ADDITIVE:`Lisäys`,
    ADDRESS:`Osoite`,
    ADDRESS_LINE1: `Osoiterivi 1`,
    ADDRESS_LINE1_REQUIRED: `Osoiterivi 1 vaaditaan`,
    ADDRESS_LINE2: `Osoiterivi 2`,
    ADJ_CLM:`Säädä vaatimus`,
    ADJUST_CLAIM:`Muokkaa anomusta`,
    ADJUSTED_HOURS: `Säädetyt tunnit`,
    ADJUSTED_QUANTITY: `Muokkaa anomusta`,
    ADJUSTMENT_TYPE:`Säätötyyppi`,
    ADVANCED_CLAIM_SUMMARY:`Lisäanomusyhteenveto`,
    AFTER_DELIVERY_INSPECTION:`TOIMITUSTARKASTUKSEN JÄLKEEN`,
    AGENCY_NAME:`Viraston nimi`,
    ALL:`Kaikki`,
    ALL_ACCOUNTS:`Kaikki tilit`,
    ALL_CLAIMS:`Kaikki anomukset`,
    ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW:`Kaikki väitteet on tarkistettava (lisätietoja on JD WAM 110.08 -asiakirjassa)`,
    ALL_CLAIMS_TAB:`Kaikki anomukset ({count, number})`,
    ALL_PART_REQUESTS:`Kaikki osapyynnöt`,
    ALL_PART_REQUESTS_WITH_COUNT:`Kaikki osapyynnöt ({count})`,
    ALL_PARTS_RETURNED:`Kaikki osat palautettu`,
    AMOUNT:`Summa`,
    AMOUNT_1:`Summa 1`,
    AMOUNT_2:`Summa 2`,
    AMOUNT_3:`Summa 3`,
    AMOUNT_OF_USE:`Käyttömäärä`,
    AMOUNT_OF_USE_ACCEPETD: `Hyväksytty käyttömäärä`,
    AMOUNT_OF_USE_CREATED_SUCCESSFULLY: `Luodun käytön määrä onnistui`,
    AMOUNT_OF_USE_HISTORY_WITH_COUNT:`Käyttöhistorian määrä ({count})`,
    AMOUNT_OF_USE_IS_REQUIRED:`Käyttömäärä on pakollinen`,
    AMOUNT_OF_USE_REJECTED: `Käytön määrä hylätty`,
    AMOUNT_OF_USE_REQUESTS_STATUS: `Käyttöpyyntöjen tila`,
    AMOUNT_OF_USE_REQUESTS_WITH_COUNT: `Käyttöpyyntöjen määrä ({count})`,
    AMOUNT_OF_USE_REQUIRED:`Käyttömäärä on pakollinen`,
    AMOUNT_OF_USE_UNITS_REQUIRED:`Tarvittavien käyttöyksiköiden määrä`,
    AMOUNT_RECORDED:`Tallennettu summa`,
    AMOUNT_TO_BE_DEBITED: `Hyvitettävä summa`,
    APLYPIP:`Lisää PIP-kampanjakoodi`,
    APPLICATION:`Sovellus`,
    APPLICATION_IS_REQUIRED:`Sovellus on pakollinen`,
    APPLY:`Lisää`,
    APPLY_TRAVEL:`Lisää matkustus`,
    APPROVAL_DEALER_COMMENTS:`Hyväksynnän jälleenmyyjän kommentit`,
    APPROVAL_DETAILS:`Hyväksymistiedot`,
    APPROVAL_LEVELS:`Hyväksyntätasot`,
    APPROVAL_REMARKS: `Hyväksyntähuomautukset`,
    APPROVAL_STATUS: `Hyväksynnän tila`,
    APPROVE:`Hyväksy`,
    APPROVE_AMOUNT_OF_USE: `Hyväksy käyttömäärä`,
    APPROVE_LABOR_RATE:`Hyväksy Labor Rate`,
    APPROVE_MACHINE_STATUS_UPDATE:`Hyväksy koneen tilan päivitys`,
    APPROVE_PIP_CODE_REQUEST:`Hyväksy PIP-koodipyyntö`,
    APPROVE_SPECIAL_ALLOWANCE_CLAIM:`Hyväksy erikoiskorvausanomus`,
    APPROVED:`Hyväksytty`,
    APPROVED_CORE_VALUE:`Hyväksytty kuoripantti`,
    APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE:`Hyväksytty päivämäärä ei voi olla ennen luontipäivää`,
    APPROVED_DIAGNOSTIC_AMOUNT:`Hyväksytty diagnostiikan summa`,
    APPROVED_DIAGNOSTIC_HOURS:`Hyväksytyt diagnostiikkatunnit`,
    APPROVED_IS_REQUIRED:`Hyväksyntä on pakollinen`,
    APPROVED_LABOR_ADDITIVE:`Hyväksytty työlisä`,
    APPROVED_LABOR_AMOUNT:`Hyväksytty työmäärä`,
    APPROVED_LABOR_HOURS:`Hyväksytyt työtunnit`,
    APPROVED_LABOR_TOTAL:`Hyväksytty työ yhteensä`,
    APPROVED_ON_SHELF_COST:`Hyväksytty hyllytyksessä`,
    APPROVED_OTHER_CREDITS:`Hyväksytyt muut hyvitykset`,
    APPROVED_PARTS:`Hyväksytyt osat`,
    APPROVED_PARTS_ADDITIVE:`Hyväksyttyjen osien lisä`,
    APPROVED_PARTS_TOTAL:`Hyväksytyt osat yhteensä`,
    APPROVED_REJECTED:`Hyväksytty/hylätty`,
    APPROVED_REPAIR_AMOUNT:`Hyväksytty korjaussumma`,
    APPROVED_REPAIR_HOURS:`Hyväksytyt korjaustunnit`,
    APPROVED_TAXES_TOTAL:`Hyväksytyt verot yhteensä`,
    APPROVED_TRAVEL_TOTAL:`Hyväksytyt matkakulut yhteensä`,
    APPROVER: `Hyväksyjä`,
    ASCENDING:`Nouseva`,
    ATTACHMENTS:`Liitteet`,
    AUDIT_NUMBER:`Tilintarkastuksen numero`,
    AUDIT_PLANNED:`Tarkastus suunniteltu`,
    AUDIT_REQUIREMENT:`Tarkastusvaatimus`,
    AUDIT_RESULTS:`Tarkastustulokset`,
    AUDIT_STATUS:`Tarkastuksen tila`,
    AUDIT_SUBMITTED_SUCCESSFULLY:`Tarkastus lähetetty onnistuneesti`,
    AUDIT_SUMMARY:`Tarkastusyhteenveto`,
    AUDIT_TYPE:`Tarkastustyyppi`,
    AUDITS:`Tarkastukset`,
    AUDITS_DUE_WITH_COUNT:`{countToDisplay} tarkistusta erääntyy`,
    AUDITS_DUE_WITHIN_30_DAYS:`{countToDisplay} {count, monikko, yksi {Audit} muu {Audit}} erääntyy 30 päivän kuluessa`,
    AUDITS_PAST_DUE_WITH_COUNT:`{countToDisplay} {count, monikko, yksi {Audit} muu {audit} erääntynyt`,
    AUTHORIZATION_NUMBER:`Varmennusnumero`,
    AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM:`Lähetä automaattisesti jälleenmyyjän liiketoimintajärjestelmästä`,
    AVAILABLE:`KÄYTETTÄVISSÄ`,
    AVAILABLE_COLUMNS:`Käytettävissä olevat sarakkeet`,
    AVERAGE_DIAGNOSTICS_HOURS:`Keskimääräiset diagnostiikkatunnit`,
    AVERAGE_LUG_HEIGHT:`Keskimääräinen lavankorkeus`,
    AVERAGE_LUG_HEIGHT_IS_REQUIRED:`Keskimääräinen lavan korkeus vaaditaan`,
    AVERAGE_REPAIR_HOURS:`Keskimääräiset korjaustunnit`,
    AVERAGE_REPLACEMENT_HOURS:`Keskimääräiset vaihtotunnit`,
    AVERAGE_TECH_PAY_RATE:`Keskimääräinen tekninen palkkio`,
    BACK:`Takaisin`,
    BACK_TO_AUDIT:`Takaisin tarkastukseen`,
    BASE_MACHINE:`Peruskone`,
    BASE_MACHINE_IMPLEMENTS: `Koneen perustyökoneet`,
    BASE_MACHINE_PIN: `Koneen PIN-koodi`,
    BASIC_WARRANTY_ENDS:`Perustakuun päät`,
    BASIC_WARRANTY_ESTIMATOR:`Perustakuun arviointi`,
    BASIC_WARRANTY_STARTS:`Perustakuu alkaa`,
    BASIS_FOR_SETTLEMENT:`Korvauksen peruste`,
    BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: `Korvauksen peruste / Tarkastuksen kommenttien perusteet`,
    BASIS_FOR_SETTLEMENT_IS_REQUIRED:`Korvauksen peruste on pakollinen tieto`,
    BATTERY:`Akku`,
    BEGIN_DATE:`Alkamispäivämäärä`,
    BRANCH:`Haara`,
    BUILT:`Sisäinen`,
    BUSINESS_END: `Liiketoiminnan loppu`,
    CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE:`Voiko koneen palauttaa käyttöön?`,
    CANCEL:`Peruuta`,
    CERTIFIED_LETTER_SENT:`Sertifioitu kirje lähetetty`,
    CGST:`CGST`,
    CHANGE_RESPONSIBLE_DEALER:`Vaihda vastuullinen jälleenmyyjä`,
    CHANGE_STATUS:`Muuta tilaa`,
    CHANGE_STATUS_FOR:`Muuta {pin} tilaa`,
    CHANGED:`Muutettu`,
    CHANGED_BY:`Muuttanut`,
    CHANGED_ON:`Muutettu`,
    CHINESE:`kiina`,
    CITY:`Kaupunki`,
    CITY_REQUIRED: `Paikkakunta vaaditaan`,
    CLAIM:`Anomus`,
    CLAIM_COUNT_WITH_PARENTHESIS:`({countToDisplay} {count, plural, one {Anomus} other {Anomusta}})`,
    CLAIM_DEBIT:`Anomuksen debet`,
    CLAIM_DETAILS:`Anomuksen tiedot`,
    CLAIM_DRAFT:`Luonnos`,
    CLAIM_HISTORY:`24 kuukauden takuuanomushistoria`,
    CLAIM_HISTORY_WITH_COUNT:`24 kuukauden takuuhistoria ({count})`,
    CLAIM_NUMBER:`Anomuksen numero`,
    CLAIM_RECOVER_PERCENTAGE:`({%} %)`,
    CLAIM_SEARCH:`Anomushaku`,
    CLAIM_STATUS:`Anomuksen tila`,
    CLAIM_TYPE:`Anomuksen tyyppi`,
    CLAIM_TYPES:`Anomustyypit`,
    CLAIM_UPDATED_SUCCESSFULLY:`Anomuksen päivitys onnistui`,
    CLAIM_VALUE:`Anomuksen arvo`,
    CLAIM_VALUE_DETAILS:`Anomuksen arvon tiedot`,
    CLAIM_WITH_NUMBER:`Anomus {claimNumber}`,
    CLAIMS:`Anomukset`,
    CLAIMS_IN_PROGRESS:`Meneillään olevat anomukset`,
    CLAIMS_IN_PROGRESS_WITH_COUNT:`Väitteet käynnissä ({count})`,
    CLAIMS_OVERVIEW:`Anomusten yleiskuvaus`,
    CLAIMS_OVERVIEW_TAB:`Anomusten yleiskatsaus ({count})`,
    CLAIMS_WITH_COUNT:`{count} väitettä`,
    CLICK_FOR_DETAILS:`(Katso lisätietoja napsauttamalla)`,
    CLICK_TO_VIEW_ALL:`Näytä kaikki napsauttamalla`,
    CLOSE:`Sulje`,
    CLOSED_PART_REQUESTS:`Suljetut osapyynnöt`,
    CLOSING: `Sulkeminen`,
    CLOSING_ACCOUNT: `Suljetaan tili`,
    CLOSING_ACCOUNT_WITH_COUNT: `Suljetaan tiliä ({count})`,
    CODE:`Koodi`,
    COLLAPSE_ALL:`Tiivistä kaikki`,
    COMMENT:`Kommentti`,
    COMMENTS:`Kommentit`,
    COMMENTS_IS_REQUIRED:`Kommentit ovat pakollisia`,
    COMMENTS_TO_DEALER:`Jälleenmyyjän kommentit`,
    COMMON_LABOR_TYPES_WARNING: `Kaikki työtyypit eivät ole käytettävissä valituille tileille`,
    COMPANY:`Yritys`,
    COMPANY_CONTRIBUTION:`Yrityksen osuus`,
    COMPANY_CONTRIBUTION_IS_REQUIRED:`Yrityksen osuus on pakollinen`,
    COMPLAINT_CAUSE:`Mikä oli valituksen diagnostiikka?`,
    COMPLAINT_CAUSE_IS_REQUIRED:`Valitusdiagnostiikka on pakollinen`,
    COMPLAINT_CORRECTION:`Miten valitus korjattiin?`,
    COMPLAINT_CORRECTION_IS_REQUIRED:`Valitus on korjattava.`,
    COMPLETE: `Valmis`,
    COMPLETED:`Valmis`,
    COMPLETED_BY:`Suorittanut`,
    COMPLETED_DATE:`Valmistumispäivämäärä`,
    COMPLETED_IN_LAST_24_MONTHS:`Valmis viimeisten 24 kuukauden aikana`,
    COMPLETION_STATUS:`Valmistumisen tila`,
    COMPONENT:`Komponentti`,
    COMPONENT_CODE:`Komponenttikoodi`,
    COMPONENT_CREATED_SUCCESSFULLY:`Komponentin luominen onnistui`,
    COMPONENT_DELETED_SUCCESSFULLY:`Komponentin poisto onnistui`,
    COMPONENT_SERIAL_NUMBER:`Komponentin sarjanumero`,
    COMPONENT_SUCCESSFULLY_UPDATED: `Komponentin päivitys onnistui`,
    COMPONENTS:`Osat`,
    CONFIRM:`Vahvista`,
    CONFIRM_ADDITIONAL_REPAIR:`Haluatko varmasti lisätä lisäkorjauksen?`,
    CONFIRM_ADJUST_CLAIM:`Haluatko varmasti muokata tätä anomusta?`,
    CONFIRM_CLOSING_ACCOUNT: `Haluatko varmasti hyväksyä tämän siirron?`,
    CONFIRM_COPY_CLAIM:`Haluatko varmasti kopioida tämän anomuksen?`,
    CONFIRM_DELETE_ATTACHMENT:`Haluatko varmasti poistaa tämän liitteen?`,
    CONFIRM_DELETE_CLAIM:`Haluatko varmasti poistaa tämän anomuksen?`,
    CONFIRM_DELETE_MACHINE_STATUS_UPDATE:`Haluatko varmasti poistaa tämän koneen tilapyynnön?`,
    CONFIRM_DELETE_REGISTRATION:`Haluatko varmasti poistaa tämän rekisteröinnin?`,
    CONFIRM_EDIT_CLAIM:`Haluatko varmasti muokata tätä anomusta?`,
    CONFIRM_RECONCILE_CLAIM:`Haluatko varmasti täsmäyttää tämän anomuksen?`,
    CONFIRM_RESEND_XML:`Haluatko varmasti lähettää XML:n uudelleen? Odota 24-48 tuntia, jotta se näkyy.`,
    CONFIRM_SKIP_AUDIT:`Haluatko varmasti ohittaa tämän tarkistuksen?`,
    CONFIRM_UNDO_REGISTRATION: `Haluatko varmasti kumota tämän rekisteröinnin?`,
    CONFIRM_UNRECONCILE_CLAIM: `Haluatko varmasti peruuttaa tämän vaatimuksen täsmäytyksen?`,
    CONNECTED_MACHINE: `Yhdistetty kone`,
    CONTACTED:`Yhteyshenkilö`,
    CONTAINS:`Sisältää`,
    CONTRACT_NUMBER:`Sopimusnumero`,
    CONTRACT_PURCHASED:`Ostettu sopimus`,
    CONTRACT_TYPE:`Sopimustyyppi`,
    COPY_CLAIM:`Kopioi anomus`,
    CORE:`Ydin`,
    CORE_VALUE:`Ydinarvo`,
    COUNTRY:`Maa`,
    COUNTRY_REQUIRED: `Maa pakollinen`,
    COURIER_ACCOUNT_NUMBER:`Kuriiritilin numero`,
    COURIER_NAME:`Kuriirin nimi`,
    COVERAGE_DECISION: `Kattavuuspäätös`,
    COVERAGE_TYPE: `Kattavuustyyppi`,
    CRDMEM:`Hyvityslasku`,
    CREATE:`Luo`,
    CREATE_CLAIM:`Luo anomus`,
    CREATE_LAYOUT:`Luo asettelu`,
    CREATE_NON_TRACKED_PIN_HELP_TEXT:`Ennen kuin voit tehdä anomuksen tästä tuotteesta, sinun on ilmoitettava meille siitä tärkeitä tietoja`,
    CREATE_PIP_CLAIM:`Luo PIP-anomus`,
    CREATE_PIP_CLAIMS:`Luo PIP-anomukset`,
    CREATE_PRODUCT_RECORD:`Luo tuotetietue`,
    CREATE_REQUEST: `Luo pyyntö`,
    CREATE_TRANSFER_PENDING: `Siirto odottaa`,
    CREATE_TRANSFER_SERVICE_UNAVAILABLE:`Luo siirtopalvelu ei ole käytettävissä`,
    CREATED:`Luotu`,
    CREATED_BY:`Luonut`,
    CREATED_DATE:`Luontipäivämäärä`,
    CREATED_DATE_FROM: `Luontipäivämäärästä`,
    CREATED_DATE_TO: `Luontipäivään`,
    CREATED_ON:`Luotu`,
    CREATION_DATE:`Luontipäivämäärä`,
    CREDIT_MEMO:`Hyvityslasku`,
    CREDIT_MEMO_DATE:`Hyvityslaskun päivämäärä`,
    CREDIT_MEMO_ISSUE_DATE:`Myönnetty hyvityslasku`,
    CREDIT_MEMO_NUMBER:`Hyvityslaskun numero`,
    CREDIT_MEMO_PROCESS_DATE:`Hyvityslasku käsitelty`,
    CREDIT_MEMO_SELECTED:`Hyvityslasku valittu`,
    CREDIT_MEMOS:`Hyvityslaskut`,
    CRITERIA:`Kriteerit`,
    CRT:`Luo`,
    CSV_SEPARATOR:`CSV-erotin`,
    CURRENCY:`Valuutta`,
    CURRENT:`Nykyinen`,
    CURRENT_ACCOUNT:`Nykyinen tili`,
    CURRENT_AMOUNT_OF_USE:`Nykyinen käyttömäärä`,
    CURRENT_CUSTOMER: `Nykyinen asiakas`,
    CURRENT_DEALER:`Nykyinen jälleenmyyjä`,
    CURRENT_DEALER_DISTANCE: `Nykyinen jälleenmyyjän etäisyys`,
    CURRENT_DEALER_LAST_SERVICE_DATE: `Nykyinen jälleenmyyjän viimeinen huoltopäivämäärä`,
    CURRENT_DEALER_LOCATION:`Nykyinen jälleenmyyjän sijainti`,
    CURRENT_HOURS: `Nykyiset tunnit`,
    CURRENT_QUANTITY: `Aktuell kvantitet`,
    CURRENT_RESPONSIBLE_DEALER: `Nykyinen vastuullinen jälleenmyyjä`,
    CURRENT_VALUES:`Nykyiset arvot`,
    CURRENTLY_ON_RENT:`Tällä hetkellä vuokralla`,
    CUSTOM_RANGE:`Mukautettu alue`,
    CUSTOM_VALUES:`Mukautetut arvot`,
    CUSTOMER:`Asiakas`,
    CUSTOMER_CONTRIBUTION:`Asiakkaan osuus`,
    CUSTOMER_CONTRIBUTION_IS_REQUIRED:`Asiakkaan osallistuminen on pakollinen`,
    CUSTOMER_CREATED_SUCCESSFULLY:`Asiakkaan luonti onnistui`,
    CUSTOMER_DETAILS:`Asiakkaan tiedot`,
    CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY:`Asiakkaan tietojen päivittäminen onnistui`,
    CUSTOMER_INFORMATION:`Asiakkaan tiedot`,
    CUSTOMER_INFORMATION_IS_REQUIRED:`Asiakastiedot ovat pakollisia.`,
    CUSTOMER_INVALID:`Asiakasta ei löytynyt tai luotu. Etsi asiakas`,
    CUSTOMER_NAME:`Asiakkaan nimi`,
    CUSTOMER_NAME_IS_REQUIRED:`Asiakkaan nimi on pakollinen.`,
    CUSTOMER_NOT_FOUND:`Asiakasta ei löydy`,
    CUSTOMER_REQUIRED:`Asiakas vaaditaan`,
    CUSTOMER_RESOLUTION:`Asiakkaan ratkaisu`,
    CUSTOMER_RESOLUTION_IS_REQUIRED:`Asiakkaan ratkaisu vaaditaan`,
    CUSTOMER_SEARCH:`Asiakashaku`,
    CUSTOMER_UPDATED_SUCCESSFULLY:`Asiakkaan päivitys onnistui`,
    DAMAGED_MACHINES_HELP_TEXT:`Vaurioituneiden koneiden takuu keskeytetään automaattisesti, kunnes TCSM tarkistaa tämän lomakkeen ja hyväksyy sen, jotta takuu voidaan palauttaa. Vaurioituneisiin koneisiin voidaan soveltaa vain pakollisia ja turvaohjeita.`,
    DATE:`Päivämäärä`,
    DATE_FORMAT:`Päivämäärän muoto`,
    DATE_ISSUED:`Myöntämispäivämäärä`,
    DATE_OF_CERTIFIED_LETTER:`Sertifioidun kirjeen päivämäärä`,
    DATE_OF_EVENT_CAUSING_DAMAGE:`Vahingon aiheuttaneen tapahtuman päivämäärä`,
    DATE_OF_LAST_PERSONAL_CONTACT:`Edellisen henkilökohtaisen yhteystiedon päivämäärä`,
    DATE_RECALLED_PART_WAS_SHIPPED_SENT:`Peruutetun osan lähetyksen/lähetyksen päivämäärä`,
    DATE_REFUSED:`Hylkäämispäivämäärä`,
    DATE_SUBMITTED: `Lähetyspäivä`,
    DAYS_FROM_REGISTRATION:`Päivää rekisteröinnistä`,
    DAYS_LEFT:`Päiviä jäljellä`,
    DAYS_LEFT_WITH_COUNT:`{daysToDisplay} {days, plural, one {Day} other {Days}} Left`,
    DAYS_ON_RENT:`Vuokrauspäivät`,
    DAYS_REMAINING:`Päiviä jäljellä`,
    DAYS_REMAINING_WITH_COUNT:`{daysToDisplay} {days, plural, one {Day} other {Days}} jäljellä`,
    DAYS_SINCE_RECOMMENDATION: `{daysToDisplay} {days, plural, one {Day} other {Days}} Suosituksesta lähtien`,
    DAYS_TO_DISPLAY:`Näytettävät päivät`,
    DBS:`DBS`,
    DEALER:`Jälleenmyyjä`,
    DEALER_ACCOUNT:`Jälleenmyyjän tili`,
    DEALER_ACCOUNT_IS_REQUIRED:`Jälleenmyyjän tili on pakollinen`,
    DEALER_ACCOUNTS:`Jälleenmyyjän tilit`,
    DEALER_CITY:`Jälleenmyyjän paikkakunta`,
    DEALER_COMMENTS:`Jälleenmyyjän kommentit`,
    DEALER_CONTRIBUTION:`Jälleenmyyjän osuus`,
    DEALER_CONTRIBUTION_IS_REQUIRED:`Jälleenmyyjän osuus on pakollinen`,
    DEALER_HIERARCHY_ACCOUNT:`{account} ({IndustryIndicator})`,
    DEALER_INVOICE_NUMBER:`Jälleenmyyjän laskun numero`,
    DEALER_INVOICE_UPDATED:`Jälleenmyyjän lasku päivitetty`,
    DEALER_INVOICE_UPDATES:`Jälleenmyyjän lasku`,
    DEALER_INVOICES:`Jälleenmyyjän laskut`,
    DEALER_LOCATION:`Jälleenmyyjän sijainti`,
    DEALER_LOCATION_FILTER:`Suodattimen sijainnit`,
    DEALER_LOCATION_IS_REQUIRED:`Jälleenmyyjän sijainti on pakollinen`,
    DEALER_LOCATIONS:`Jälleenmyyjän sijainnit`,
    DEALER_NAME:`Jälleenmyyjän nimi`,
    DEALER_PHONE:`Jälleenmyyjän puhelinnumero`,
    DEALER_POSTAL_CODE:`Jälleenmyyjän postinumero`,
    DEALER_RECOMMENDATIONS: `Jälleenmyyjän suositukset`,
    DEALER_RECOMMENDATIONS_TAB: `Jälleenmyyjän suositukset ({count})`,
    DEALER_REVIEW_REQUEST_SUCCESSFULLY: `Jälleenmyyjän uudelleentarkastelu onnistui`,
    DEALER_SEARCH:`Jälleenmyyjähaku`,
    DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT:`Kirjoita jälleenmyyjien hakuun käytettävä nimi, paikkakunta tai tili`,
    DEALER_STATE:`Jälleenmyyjän tila`,
    DEALER_SUBMISSION_WITH_CURRENCY:`Jälleenmyyjän lähetys ({valuutta})`,
    DEALER_TRANSFER_HISTORY:`Jälleenmyyjän siirtohistoria`,
    DEALER_TRANSFER_REQUEST_PARTIALLY_SUCCESSFUL: `Joidenkin siirtopyyntöjen luonti onnistui. Prosessi on jäljellä yksitellen.`,
    DEALER_TRANSFER_REQUEST_SUCCESSFULLY: `Jälleenmyyjän siirtopyynnön Jonotus Onnistui`,
    DEALER_WARRANTY:`Jälleenmyyjän takuu`,
    DEALERS:`Jälleenmyyjät`,
    DEALERSHIP:`Jälleenmyyjä`,
    DEBIT:`Debet`,
    DEBIT_AMOUNT:`Veloitussumma`,
    DEBIT_FOR_CLAIM_NUMBER:`Veloitus: {claimNumber}`,
    DEBIT_REQUIRED:`Veloitus vaaditaan`,
    DEBIT_REQUIRED_STATUS:`Veloituksen pakollinen tila`,
    DEBIT_SUBMITTED_SUCCESSFULLY:`Debet lähetetty onnistuneesti`,
    DEBIT_TYPE:`Veloitustyyppi`,
    DEBITED:`Hyvitetty`,
    DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS:`Tähän vaatimukseen liittyvät veloitukset on suoritettava manuaalisessa veloitusprosessissa`,
    DECIMAL_FORMAT:`Desimaalimuoto`,
    DECISION_UPDATED: `Päätös päivitetty`,
    DECLINE:`Hylkää`,
    DEDUCTIBLE:`Vähennettävä`,
    DEERE_REMARKS:`Deeren huomautukset`,
    DEFAULT_WARRANTY:`Oletustakuu`,
    DEL:`Poista`,
    DELETE:`Poista`,
    DELETE_ATTACHMENT:`Poista liite`,
    DELETE_CLAIM:`Poista anomus`,
    DELETE_MACHINE_STATUS_UPDATE:`Poista koneen tilapäivitys`,
    DELETE_MACHINE_STATUS_UPDATE_SUCCESS:`Koneen tilan poisto onnistui`,
    DELETE_REGISTRATION:`Poista rekisteröinti`,
    DELETE_REGISTRATION_SUCCESS:`Rekisteröinnin poisto onnistui`,
    DELETED:`Poistettu`,
    DELETED_BY:`Poistaja`,
    DELIVERED:`Toimitettu`,
    DELIVERED_IS_REQUIRED:`Toimitustieto on pakollinen`,
    DELIVERY_DATE:`Toimituspäivämäärä`,
    DELIVERY_DATE_REQUIRED:`Toimituspäivämäärä vaaditaan`,
    DELIVERY_DATES:`Toimituspäivämäärät`,
    DELIVERY_NO_DOCUMENTS:`Toimitus, ei asiakirjoja`,
    DEMO_RENTAL_BEGIN_DATE:`Esittelyn/vuokrauksen aloituspäivämäärä`,
    DEMO_RENTAL_CHOOSE_DEALERS_STATUS:`Valitse jälleenmyyjät ja tila`,
    DEMO_RENTAL_END_DATE:`Esittelyn/vuokrauksen päättymispäivä`,
    DEMO_RENTAL_HISTORY:`Esittelykoneen vuokrahistoria`,
    DENY:`Estä`,
    DENY_AMOUNT_OF_USE: `Estä käytön määrä`,
    DENY_MACHINE_STATUS_UPDATE:`Estä koneen tilan päivitys`,
    DENY_PIP_CODE_REQUEST:`Estä PIP-koodipyyntö`,
    DESCENDING:`Laskeva`,
    DESCRIPTION:`Kuvaus`,
    DESCRIPTION_OF_DAMAGE:`Vahingon kuvaus`,
    DESCRIPTION_OF_EVENT_CAUSING_DAMAGE:`Vahingon aiheuttavan tapahtuman kuvaus`,
    DESELECT_ALL:`Poista kaikkien valinta`,
    DETAILS:`Tiedot`,
    DIAGNOSTICS_COVERED:`Diagnostiikka käytössä`,
    DIS_VSR:`Näytä viestit`,
    DISPLAY:`Näyttö`,
    DISPLAY_CLAIM:`Näytä anomus`,
    DISPLAY_CREDIT_MEMO:`Näytä hyvityslasku`,
    DISPLAY_FORMAT:`Näyttömuoto`,
    DISPLAY_PRODUCT:`Näytä tuote`,
    DISPLAY_TAG:`Näyttötunniste`,
    DISTANCE:`Etäisyys`,
    DISTANCE_FROM_CURRENT_DEALER: `Etäisyys nykyisestä jälleenmyyjästä`,
    DISTANCE_FROM_POTENTIAL_DEALER: `Etäisyys potentiaalisesta jälleenmyyjästä`,
    DISTANCE_FROM_RESPONSIBLE_ACCOUNT: `Etäisyys vastuulliselta tililtä`,
    DIVISION:`Divisioona`,
    DIVISION_SUMMARY:`Jakoyhteenveto`,
    DO_YOU_WANT_TO_SAVE_YOUR_CHANGES:`Haluatko tallentaa muutokset?`,
    DOES_NOT_CONTAIN:`Ei sisällä`,
    DOWNLOAD_TO_EXCEL:`Lataa Exceliin`,
    DOWNTIME:`Käyttökatkokset`,
    DOWNTIME_IS_REQUIRED:`Käyttämättömyysaika on pakollinen`,
    DRAFT:`Tallenna luonnoksena`,
    DTAC_CASE:`DTAC-tapaus`,
    DTAC_CASE_NUMBER:`DTAC-tapauksen numero`,
    DTAC_SOLUTION:`DTAC-ratkaisu`,
    DUE_DATE:`Määräpäivä`,
    DUE_WITHIN_3_MONTHS:`Määräpäivä 3 kuukauden kuluessa`,
    DUPLICATE_PIN_PLATE: `PIN-kyltin monistaminen`,
    DUPLICATE_PIN_PLATE_REPORT: `PIN-kyltin monistamisraportti`,
    DUPLICATE_PIN_PLATE_REQUEST_UPDATED: `PIN-kyltin kaksoiskappalepyyntö päivitetty`,
    DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: `PIN-kyltin kaksoiskappalepyynnön luominen onnistui`,
    DUPLICATE_PIN_PLATE_WITH_COUNT: `PIN-kylttipyynnön kaksoiskappale ({count})`,
    EDIT:`Muokkaa`,
    EDIT_CUSTOMER:`Muokkaa asiakasta`,
    EDIT_LAYOUT:`Muokkaa asettelua`,
    EDIT_WITH_PARENTHESES:`(Muokkaa)`,
    EFFECTIVE:`Voimassa`,
    EFFECTIVE_DATE:`Voimaantulopäivä`,
    EMAIL:`Sähköposti`,
    EMISSIONS_PART_SEARCH:`Päästöosien haku`,
    END_DATE:`Päättymispäivä`,
    END_USE:`Loppukäyttö`,
    END_USE_CODE:`Loppukäyttökoodi`,
    END_USE_CODE_REQUIRED:`Loppukäyttökoodi vaaditaan`,
    ENDS_WITH:`Päättyy`,
    ENGLISH:`englanti`,
    ENTER_A_NUMBER_BETWEEN_0_AND_1000:`Anna luku väliltä 0 - 1 000`,
    ENTER_A_NUMBER_BETWEEN_0_AND_10000:`Anna luku väliltä 0 - 10000`,
    ENTER_A_NUMBER_FROM_1_TO_9999:`Anna luku 1 - 9 9 999`,
    ENTER_A_PART_NUMBER:`Anna osanumero`,
    ENTER_COMMENTS_BEFORE_ACCEPTING:`Kirjoita kommentit ennen hyväksymistä`,
    ENTITY_ID: `Yksikön tunnus`,
    EQUALS:`Yhtä suuri kuin`,
    ERROR:`VIRHE:`,
    ERROR_MESSAGE_TITLE:`Tapahtui virhe:`,
    ERROR_MESSAGES:`Virhesanomat`,
    ERROR_MESSAGES_TITLE:`On tapahtunut useita virheitä:`,
    ERROR_NETWORK_ISSUES:`Verkkovirhe esti joidenkin tietojen lataamisen - yritä uudelleen`,
    ERROR_NO_DATA_TO_EXPORT:`Ei vietäviä tietoja`,
    ERROR_RETRIEVING_CUSTOMER_INFORMATION:`Virhe noudettaessa asiakastietoja`,
    ERROR_SAP:`Yhteyden muodostaminen palvelimeen ei onnistu.  Jos ongelma ei poistu, pyydä apua ongelman ratkaisemiseen Ota yhteyttä -linkin avulla.`,
    ERROR_SESSION:`Istuntosi on vanhentunut.  Kirjaudu takaisin sisään päivittämällä sivu.`,
    ERROR_UNHANDLED:`Järjestelmä havaitsi odottamattoman virheen.  Jos ongelma ei poistu, pyydä apua ongelman ratkaisemiseen käyttämällä Ohje-toimintoa tai Ota yhteyttä -linkkiä.`,
    ERROR_UPLOADING_FILE:`Tiedostoa ei lisätty`,
    ESTIMATED_BASIC_DATE:`Arvioitu peruspäivämäärä`,
    ESTIMATED_BASIC_DAYS:`Arvioidut peruspäivät`,
    ESTIMATED_HOURS: `Arvioidut tunnit`,
    ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED:`Arviot eivät välttämättä vastaa esittelytilaa tai tunteja, joita ei ole vielä ilmoitettu`,
    EXCEEDS_DEMO_THRESHOLD:`Ylittää esittelyrajan`,
    EXCHANGE_RATE:`Vaihtokurssi`,
    EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT:`Ohitetut PIN-koodit eivät sisälly tähän raporttiin.`,
    EXECUTE:`Suorita`,
    EXPAND_ALL:`Laajenna kaikki`,
    EXPECTED_FIRST_USE:`Odotettu ensimmäinen käyttö`,
    EXPIRATION_DATE:`Vanhentumispäivä`,
    EXPIRED:`Vanhentunut`,
    EXPIRED_PART_REQUESTS:`Vanhentuneet varaosapyynnöt`,
    EXPIRED_PIPS:`Vanhentuneet PIP-ohjelmat`,
    EXPIRES:`Vanhenee`,
    EXPIRING_SOON:`Vanhenee pian`,
    EXPORT:`Vie`,
    EXTENDED_WARRANTY:`Laajennettu takuu`,
    FACTORY:`TEHDAS`,
    FACTORY_DUPLICATE_PIN_PLATE: `PIN-kyltin monistaminen`,
    FACTORY_NAME: `Tehtaan nimi`,
    FACTORY_USERS_TAB: `PIN-kyltin monistaminen ({count})`,
    FAILED:`Epäonnistui`,
    FAILED_AREA:`Epäonnistunut alue`,
    FAILED_AREA_IS_REQUIRED:`Epäonnistunut alue on pakollinen`,
    FAILED_DATE:`Epäonnistumispäivämäärä`,
    FAILED_DATE_IS_REQUIRED:`Epäonnistumispäivämäärä on pakollinen`,
    FAILED_MODE:`Epäonnistunut tila`,
    FAILED_MODE_COMMENTS:`Epäonnistuneen tilan kommentit`,
    FAILED_PART:`Epäonnistunut osa`,
    FAILED_PART_DESCRIPTION:`Epäonnistuneen osan kuvaus`,
    FAILED_PART_IS_A_REMAN_PART:`Epäonnistunut osa on ReMan-osa`,
    FAILED_PART_IS_REQUIRED:`Epäonnistunut osa vaaditaan`,
    FAILED_PART_SERIAL:`Epäonnistuneen osan sarja`,
    FAILED_PART_SERIAL_IS_REQUIRED:`Epäonnistuneen osan sarja vaaditaan`,
    FAILURE_DATE:`Virheen päivämäärä`,
    FAILURE_INFORMATION:`Virhetiedot`,
    FAILURE_MODE:`Vikatila`,
    FAILURE_MODE_IS_REQUIRED:`Epäonnistui-tila on pakollinen`,
    FAILURE_PART:`Epäonnistunut osa`,
    FAILURE_PART_DESCRIPTION:`Vian osan kuvaus`,
    FAILURE_PART_IS_REQUIRED:`Vika-osa vaaditaan`,
    FAILURE_TO_RETURN_PARTS_WARNING:`Jos pyydettyjä osia ei palauteta, seurauksena voi olla veloitus.`,
    FAVORITES:`Suosikit`,
    FILE_NAME:`Tiedoston nimi`,
    FILE_SIZE_IS_TOO_BIG:`Tiedoston koko on liian suuri (enimmäiskoko: 100 Mt)`,
    FILE_SIZE_IS_TOO_BIG_CSV:`Tiedoston koko on liian suuri (enimmäiskoko: 1 Mt)`,
    FILE_UPLOAD_MESSAGE:`Pudota tiedostot tähän tai lisää tiedostoja napsauttamalla (Enimmäiskoko: 100 Mt)`,
    FILE_UPLOAD_MESSAGE_CSV:`Pudota tiedostot tähän tai lisää tiedostoja napsauttamalla (Enimmäiskoko: 1 Mt)`,
    FILE_UPLOAD_MESSAGE_IMAGE:`Vedä ja pudota kuvia tähän tai napsauta tätä, kun haluat lisätä kuvia (enimmäiskoko: 100 Mt).`,
    FILE_UPLOAD_MESSAGE_SINGLE:`Pudota yksi tiedosto tähän tai napsauta kohtaa Lisää (Enimmäiskoko: 100 Mt)`,
    FILE_UPLOAD_UNABLE_TO_READ: `Järjestelmä ei voinut lukea tiedostoasi.  Vertaa sitä malliin ja yritä uudelleen.`,
    FILES:`Tiedostot`,
    FILTER_DEALER_RECOMMENDATIONS_MESSAGE: `Ei tuloksia. Hae kaikista suosituksista painamalla Enter.`,
    FILTER_PLACEHOLDER:`Suodata tulokset`,
    FILTER_WITH_ELLIPSIS:`Suodata...`,
    FILTERED_BY_COLUMN_ID:`Suodatettu: {ColumnId}`,
    FIND_CUSTOMER:`Etsi asiakas`,
    FINNISH: `Suomi`,
    FIRST_MAINTENANCE:`ENSIMMÄINEN HUOLTO`,
    FIRST_NAME:`Etunimi`,
    FIRST_NAME_IS_REQUIRED:`Etunimi on pakollinen`,
    FIRST_SHIP_TO_LOCATION:`Ensimmäinen toimituspaikka`,
    FIRST_USE:`Ensimmäinen käyttö`,
    FISCAL_YEAR:`Tilikausi`,
    FLUID_SAMPLING_REQUIRED:`Nestenäyte vaaditaan`,
    FORWARDED:`Välitetty`,
    FRENCH:`ranska`,
    FROM:`Lähettäjä`,
    FRWRD:`Eteenpäin`,
    FULL_DEBIT:`Täysi debet`,
    GENERAL:`Yleistä`,
    GERMAN:`saksa`,
    GET_MAINTENANCE_PLANS:`Hae huoltosuunnitelmat`,
    GOODS_INSTALLATION_VAT:`Tavaroiden asennuksen ALV`,
    GRACE_PERIOD:`Grace period`,
    GREATER_THAN:`Suurempi kuin`,
    GREATER_THAN_OR_EQUALS:`Suurempi tai yhtä suuri kuin`,
    GROUP_COMPLETE:`Ryhmä valmis`,
    GST_PERCENTAGE:`GST-prosentti`,
    H_LIMIT:`Tuntiraja`,
    HISTORY_TO_DISPLAY:`Näytettävä historia (päivää)`,
    HOME:`Aloitussivu`,
    HOUR_LIMIT:`Tuntiraja`,
    HOURS:`Tunnit`,
    HOURS_ON_RENT:`Tunteja vuokrassa`,
    HSN_SAC_CODE:`HSN/SAC-koodi`,
    IGST:`IGST`,
    IMPLEMENTS: `Työkoneet`,
    IN_RANGE:`Alueella`,
    INCENTIVE:`Kannustin`,
    INCENTIVE_PROGRAMS: `Kannustinohjelmat`,
    INCLUDE_FULLY_COMPLETE:`Sisällytä täysin valmiit PIP-ohjelmat`,
    INDICATES_REQUIRED_FIELD:`Ilmaisee pakollisen kentän`,
    INFO_MESSAGE_TITLE:`Järjestelmäilmoitus lähetettiin:`,
    INFO_MESSAGES:`Tietosanomat`,
    INFO_MESSAGES_TITLE:`Useita järjestelmäilmoituksia on lähetetty:`,
    INFO_REQUEST_STATUS_ERROR:`Tiedot voidaan lähettää tämän pyynnön kanssa.`,
    INFORMATION:`Tiedot`,
    INFORMATION_REQUEST:`Tietopyyntö`,
    INFORMATION_REQUEST_STATUS:`Tietopyynnön tila`,
    INPUT_PIN:`PIN-koodi`,
    INSPECTION:`Tarkastus`,
    INSTALLED_BY:`Asentaja`,
    INSTALLED_BY_IS_REQUIRED:`Asentajatieto on pakollinen`,
    INTERNAL_DEERE_COMMENTS:`Deeren sisäiset kommentit`,
    INTERNAL_EQUIPMENT_NOTES: `Sisäiset laitehuomautukset`,
    INTERVAL_BEGINS:`Aikaväli alkaa`,
    INTERVAL_ENDS:`Aikavälin loppu`,
    INTERVAL_TYPE_DESCRIPTION:`Aikavälin tyypin kuvaus`,
    INVOICE_ACCOUNT:`Laskutustili`,
    INVOICE_DEALER:`Laskun jälleenmyyjä`,
    INVOICE_NUMBER:`Laskun numero`,
    INVOICE_REQUEST:`Laskutuspyyntö`,
    INVOICE_SENT:`Lasku lähetetty`,
    INVOICE_UPDATED_SUCCESSFULLY:`Laskun päivitys onnistui`,
    INVOICED:`Laskutettu`,
    INVOICED_TO:`Laskutettu`,
    IRC_PIN_MESSAGE: `Asiakkaalla on oikeus ilmaiseen matkustusaikaan ja matkaan ensimmäisten 500 tunnin tai 12 kuukauden ajan koneen omistajuudesta.`,
    ISSUED:`Myönnetty`,
    ITALIAN:`italia`,
    ITEM:`Kohde`,
    ITEM_NUMBER:`Nimikkeen numero`,
    ITEM_NUMBER_IS_REQUIRED:`Nimikenumero on pakollinen`,
    JDLINK_EXPIRES:`JDLink vanhenee`,
    JDP_COMMENTS:`JDP-kommentit`,
    JDP_COMMENTS_IS_REQUIRED:`JDP-kommentit ovat pakollisia`,
    JDP_CUSTOMER_RESOLUTION:`JDP-asiakasratkaisu`,
    JDP_CUSTOMER_RESOLUTION_IS_REQUIRED:`JDP-asiakasratkaisu vaaditaan`,
    JDP_REASON:`JDP-syy`,
    JDP_REASON_IS_REQUIRED:`JDP-syy on pakollinen`,
    LABOR:`Työ`,
    LABOR_ADDITIVE:`Työlisä`,
    LABOR_ADDITIVE_COMPLETION_DETAIL:`Työn lisän valmistumistiedot`,
    LABOR_ADDITIVE_PIPS:`Työlisän PIP-ohjelmat`,
    LABOR_ADDITIVE_TAB:`Lisä ({count})`,
    LABOR_ADJUSTMENT: `Työn mukauttaminen`,
    LABOR_COMMENTS:`Työkommentit`,
    LABOR_HOURS:`Työtunnit`,
    LABOR_ITEM_DETAILS:`Työ - {määrä} {yksikkö} {kuvaus}`,
    LABOR_RATE_APPROVED_SUCCESSFULLY:`Työvoimaprosentti hyväksytty onnistuneesti`,
    LABOR_RATE_CHANGE_SUBMITTED:`Työmäärän muutos lähetetty`,
    LABOR_RATE_CHANGES_WITH_COUNT:`Työmäärän muutokset ({count})`,
    LABOR_RATE_CONFIRM:`Pyydetty nopeus on pienempi kuin nykyinen nopeus.  Haluatko varmasti lähettää pyynnön?`,
    LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: `Punaisella tekstillä ilmaisevat, että korotus on yli 10 % nykyisestä tasosta`,
    LABOR_RATE_HISTORY:`Työhinnan historia`,
    LABOR_RATE_REJECTED_SUCCESSFULLY:`Työvoimaprosentti hylätty`,
    LABOR_RATE_REQUESTS_STATUS: `Työmääräpyyntöjen tila`,
    LABOR_RATE_RETURNED_SUCCESSFULLY: `Työvoimaprosentti palautettu`,
    LABOR_RATES:`Työvoimahinnat`,
    LABOR_STATS:`Työtilastot`,
    LABOR_TOTAL:`Työ yhteensä`,
    LABOR_TYPE:`Työn tyyppi`,
    LABOR_VALUE:`Työn arvo`,
    LABOR_WITH_COUNT:`Työ ({count})`,
    LANGUAGE:`Kieli`,
    LAST_LOCATION_FROM: `Viimeinen sijainti kohteesta`,
    LAST_NAME:`Sukunimi`,
    LAST_NAME_IS_REQUIRED:`Sukunimi on pakollinen`,
    LAST_PERSONAL_CONTACT:`Viimeinen henkilökohtainen yhteyshenkilö`,
    LAST_SEEN: `Viimeksi nähty`,
    LAST_SEEN_AT_RESPONSIBLE_ACCOUNT: `Nähty viimeksi vastuullisella tilillä`,
    LATEST: `Viimeisin`,
    LAW_ENFORCEMENT_AGENCY_DETAILS:`Lainvalvontaviraston tiedot`,
    LAYOUT_CREATED_SUCCESSFULLY:`Asettelun luominen onnistui`,
    LAYOUT_DELETED_SUCCESSFULLY:`Asettelu poistettu`,
    LAYOUT_NAME:`Asettelun nimi`,
    LAYOUT_UPDATED_SUCCESSFULLY:`Asettelun päivitys onnistui`,
    LEAD_ACCOUNT:`Liiditili`,
    LEAD_DEALER:`Liidin jälleenmyyjä`,
    LESS_THAN:`Alle`,
    LESS_THAN_OR_EQUALS:`Pienempi tai yhtä suuri kuin`,
    LICENSE_PLATE_NUMBER:`Rekisterikilven numero`,
    LIFETIME:`Käyttöikä`,
    LINE_ITEMS_EXPORT:`Rivinimikkeiden vienti`,
    LIST:`Luettelo`,
    LIST_TOTAL:`Luettelo yhteensä`,
    LOCATION:`Sijainti`,
    LOCATION_DUE:`Sijainnin määräaika`,
    LOCATIONS:`Sijainnit`,
    LOCATIONS_WITH_COUNT:`Sijainnit ({count})`,
    MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER:`Kone on jo rekisteröity tälle asiakkaalle`,
    MACHINE_INFORMATION:`Koneen tiedot`,
    MACHINE_MODEL_TYPE: `Koneen malli/tyyppi`,
    MACHINE_MODEL_TYPE_REQUIRED: `Koneen malli/tyyppi vaaditaan`,
    MACHINE_STATUS:`Koneen tila`,
    MACHINE_STATUS_UPDATE:`Koneen tilan päivitys`,
    MACHINE_STATUS_UPDATE_ACCEPTED:`Koneen tilan päivitys hyväksytty`,
    MACHINE_STATUS_UPDATE_DOCUMENT:`Koneen tilan päivitysasiakirja`,
    MACHINE_STATUS_UPDATE_REJECTED:`Koneen tilan päivitys hylätty`,
    MACHINE_STATUS_UPDATES_WITH_COUNT:`Koneen tilan päivitykset ({count})`,
    MACHINE_TYPE:`Koneen tyyppi`,
    MACHINE_TYPE_IS_REQUIRED:`Konetyyppi vaaditaan`,
    MACHINE_USE:`Koneen käyttö`,
    MAILING_RECIPIENT: `Postituksen vastaanottaja (etu- ja sukunimi)`,
    MAILING_RECIPIENT_REQUIRED: `Postituksen vastaanottaja vaaditaan`,
    MAINTENANCE:`Huolto`,
    MAINTENANCE_PLAN:`Huoltosuunnitelmat`,
    MAINTENANCE_PLAN_INFO:`Huoltosuunnitelman tiedot`,
    MARK_AS_INPROCESS: `Merkitse keskeneräiseksi`,
    MARK_AS_REVIEW: `Merkitse tarkistetuksi`,
    MARKETING_INCENTIVE:`Markkinointi - kannustava`,
    MARKETING_JD_PROMISE:`Markkinointi - JD-lupaus`,
    MARKETING_MAINTENANCE_PLAN:`Markkinointi - Huoltosuunnitelma`,
    MARKETING_MASS_CHANNEL_FOLLOWUP:`Markkinointi - massakanavan seuranta`,
    MARKETING_MASS_CHANNEL_PDI:`Markkinointi - Massakanava-PDI`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP:`Massakanavaasiakkaan seuranta`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT:`Muistutus - varmista, että otat yhteyttä omaan oikeusavustajaasi määrittääksesi asianmukaiset #Do Not Call# -menettelyt osavaltiossa ja liittovaltiotasolla ennen kuin toteutat jatkotoimet myyntipuhelun jälkeen -ohjelman jälkeen`,
    MASS_CHANNEL_PDI_CLAIM:`Massakanavan PDI`,
    MASTER_WARRANTY_TYPE: `Päätakuun tyyppi`,
    MATERIAL: `Materiaalin numero`,
    MERCHANDISE:`Kauppa`,
    MESSAGE:`Viesti`,
    MESSAGES:`Viestit`,
    METHOD_OF_CONTACT:`Yhteystapa`,
    METHOD_OF_CONTACT_IS_REQUIRED:`Yhteystapa on pakollinen`,
    METRIC:`Metrinen`,
    METRICS:`Mittarit`,
    MILEAGE_LIMIT:`Kilometrien raja`,
    MOBILE_PHONE: `Matkapuhelin`,
    MODEL:`Malli`,
    MODEL_NUMBER: `Mallin numero`,
    MODEL_YEAR: `Mallivuosi`,
    MODIFIED:`Muokattu`,
    MONTH_TO_DATE:`Kuukauden alusta`,
    MORE:`Enemmän`,
    MULTIPLE:`Useita`,
    NAME:`Nimi`,
    NET:`Netto`,
    NET_AMOUNT:`Nettomäärä`,
    NET_AMOUNT_PAID:`Maksettu nettomäärä`,
    NET_TOTAL:`Netto yhteensä`,
    NEW:`Uusi`,
    NEW_ACCOUNT:`Uusi tili`,
    NEW_CLAIM:`Uusi anomus`,
    NEW_CLAIM_VALUE: `Uusi vaatimusarvo`,
    NEW_CUSTOMER_REQUIRED:`Uusi asiakas vaaditaan`,
    NEW_DEALER:`Uusi jälleenmyyjä`,
    NEW_DEALER_DISTANCE: `Uusi jälleenmyyjän etäisyys`,
    NEW_DEALER_LOCATION:`Uusi jälleenmyyjän sijainti`,
    NEW_LABOR_RATE:`Uusi työmäärä`,
    NEW_REQUEST_ENTER_RATES: `Uusi pyyntö - Syötä nopeudet`,
    NEW_STATUS:`Uusi tila`,
    NEW_TRANSFER:`Uusi siirto`,
    NEW_TRANSFER_CREATED:`Uusi siirto luotu`,
    NEW_VALUE:`Uusi arvo`,
    NO:`EI`,
    NO_ACTIVE_WARRANTY:`Ei aktiivista takuuta`,
    NO_AFFECTED_PINS:`Jälleenmyyjäsi vastuulla ei ole PIN-koodeja, joihin ongelma vaikuttaa`,
    NO_AUTHORITY_TO_ACCESS:`Sinulla ei ole oikeuksia käyttää JDWS-järjestelmää. Jälleenmyyjän käyttäjät voivat tarkistaa järjestelmänvalvojan (DPA) tiedot ja ottaa yhteyttä tukeen ja saada kopion tästä virheestä`,
    NO_CLAIMS:`Anomuksia ei ole.`,
    NO_CUSTOMER_ASSOCIATED:`Asiakasta ei ole liitetty`,
    NO_CUSTOMER_SELECTED:`Asiakasta ei ole valittu`,
    NO_DEALER_INVOICES:`Ei jälleenmyyjän laskuja`,
    NO_DEALERS_MAPPED:`Käyttäjätunnukseesi ei ole määritetty jälleenmyyjiä. Ota yhteyttä järjestelmänvalvojaan.`,
    NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE:`Ei (Jos ei, kuva on esitettävä todisteena)`,
    NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT:`Tietoja ei ole saatavilla tälle tuotteelle`,
    NO_LABOR_COVERAGE:`Ei työn kattavuutta`,
    NO_LOWERCASE:`Ei`,
    NO_MATCHING_DEALERS:`Ei vastaavaa jälleenmyyjää.`,
    NO_OPEN_PART_REQUESTS:`Ei avoimia varaosapyyntöjä`,
    NO_OPEN_PIPS:`Ei avoimia PIP-ohjelmia`,
    NO_PARTS_RETURNED:`Ei palautettuja osia`,
    NO_PIP_PRODUCTS:`PIP-tuotteita ei ole.`,
    NO_PRODUCT_FOUND:`Tuotetta ei löytynyt`,
    NO_REQUIRED_ITEMS:`Pakollisia kohteita ei ole.`,
    NO_RESULTS:`Ei tuloksia`,
    NO_RESULTS_FOUND:`Tuloksia ei löytynyt`,
    NO_ROWS_TO_SHOW:`Ei näytettäviä rivejä`,
    NO_SPECIAL_INSTRUCTIONS:`Ei erityisohjeita.`,
    NO_TRAVEL:`Ei matkustus`,
    NON_RECOVERABLE_TAXES:`Ei-palautettavat verot`,
    NON_TRACKED_PINS_HELP_TEXT:`Jotkin tuotteet näkyvät takuutilassa vasta rekisteröinnin jälkeen. Haku vastaa useita näitä tuotteita.`,
    NON_TRAVEL:`Ei ajo`,
    NONE:`Ei mitään`,
    NORMAL:`NORMAALI`,
    NOT_EQUAL:`Erisuuri`,
    NOTIFICATION_ADDED_SUCCESSFULLY:`Ilmoituksen lisääminen onnistui`,
    NOTIFICATION_DELETED_SUCCESSFULLY:`Ilmoituksen poistaminen onnistui`,
    NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY:`Ilmoitusjärjestyksen päivitys onnistui`,
    NOTIFICATION_UPDATED_SUCCESSFULLY:`Ilmoituksen päivitys onnistui`,
    NOTIFICATIONS:`Ilmoitukset`,
    NUMBER_OF_DIAGNOSTICS_OCCURRENCES:`Diagnostiikkatapahtumien määrä`,
    NUMBER_OF_OPEN_PIPS:`{number} avointa PIP-osoitetta`,
    NUMBER_OF_REPAIR_OCCURRENCES:`Korjauskertojen määrä`,
    NUMBER_OF_REPLACEMENT_OCCURRENCES:`Vaihtomerkkien määrä`,
    OLD_LABOR_RATE:`Vanha labor rate`,
    ON_SHELF:`Hyllyssä`,
    ON_SHELF_COST:`Hyllyssä kusatnnus`,
    ONE_ITEM_MUST_BE_SELECTED:`Yksi kohde on valittava`,
    OPEN:`Avaa`,
    OPEN_PART_REQUESTS:`Avaa osapyynnöt`,
    OPEN_PART_REQUESTS_WITH_COUNT:`Avaa osapyynnöt ({count})`,
    OPEN_PIP_COUNT:`Avaa PIP-määrä`,
    OPEN_PIP_PROGRAMS:`PIP-rekisteri`,
    OPEN_PIPS:`Avoimet PIP-ohjelmat`,
    OPEN_PIPS_REPORT:`Avointen PIP-raportti`,
    OPEN_PIPS_TAB:`Avaa PIP-ohjelmat ({count})`,
    OPEN_PIPS_Y_N: `Avaa PIP-ohjelmat (K/E)`,
    OPERATORS_COMPLAINT:`Mikä oli käyttäjän valitus?`,
    OPERATORS_COMPLAINT_IS_REQUIRED:`Käyttäjän valitus vaaditaan`,
    OPERATORS_MANUAL_NUMBER:`Käyttöohjeen numero`,
    OPTION_CODE:`Varustekoodi`,
    OPTION_CODE_CREATED_SUCCESSFULLY:`Asetuskoodi luotu onnistuneesti`,
    OPTION_CODE_DELETED_SUCCESSFULLY:`Asetuskoodi poistettiin onnistuneesti`,
    OPTION_CODES:`Varustekoodit`,
    OR:`tai`,
    ORIGINAL_CLAIM_VALUE:`Alkuperäinen takuuhakemuksen arvo`,
    ORIGINAL_SUBMISSION_DATE:`Alkuperäinen lähetyspäivämäärä`,
    ORIGINALLY_SUBMITTED:`Alkuperäinen lähetetty`,
    OTHER:`Muut`,
    OTHER_AMOUNT_OF_USE:`Muu käyttömäärä`,
    OTHER_AMOUNT_OF_USE_REQUIRED:`Muu tarvittava käyttömäärä`,
    OTHER_CREDIT:`Muu hyvitys`,
    OTHER_CREDIT_1:`Muu hyvitys 1`,
    OTHER_CREDIT_2:`Muu hyvitys 2`,
    OTHER_CREDIT_3:`Muu hyvitys 3`,
    OTHER_CREDIT_ADJUSTMENT: `Muu hyvitysoikaisu`,
    OTHER_CREDIT_ITEM_DETAILS:`Muu hyvitys - {description} ({count} {unit})`,
    OTHER_CREDIT_TOTAL:`Muut hyvitykset yhteensä`,
    OTHER_CREDITS:`Muut hyvitykset`,
    OTHER_CREDITS_WITH_COUNT:`Muut hyvitykset ({count})`,
    OTHER_INSTRUCTIONS:`Muut ohjeet`,
    OUTPUT_PIN:`Tulostuksen PIN`,
    OVERDUE:`Erääntynyt`,
    OVERRIDE_ACCOUNT: `Ohita tili`,
    OVERRIDE_EFFECTIVE_DATE:`Ohita voimaantulopäivä`,
    OVERRIDE_SUGGESTED_ACCOUNT: `Ohita ehdotettu tili`,
    OWNERSHIP_STATUS:`Omistajan tila`,
    OWNERSHIP_STATUS_IS_REQUIRED:`Omistajan tila on pakollinen`,
    PART:`Osa`,
    PART_1:`Osa 1`,
    PART_2:`Osa 2`,
    PART_3:`Osa 3`,
    PART_4:`Osa 4`,
    PART_5:`Osa 5`,
    PART_6:`Osa 6`,
    PART_7:`Osa 7`,
    PART_8:`Osa 8`,
    PART_9:`Osa 9`,
    PART_10:`Osa 10`,
    PART_AMONT_OF_USE:`Osan käyttömäärä`,
    PART_FAMILY:`Osanimi`,
    PART_ITEM_DETAILS:`Osat - {määrä} {kuvaus} (varaosanumero {partNumber})`,
    PART_NUMBER:`Varaosanumero`,
    PART_REQUEST:`Varaosapyyntö`,
    PART_REQUEST_NUMBER:`Varaosapyyntö {rgaNumber}`,
    PART_REQUEST_STATUS:`Varaosapyynnön tila`,
    PART_REQUESTS:`Varaosapyynnöt`,
    PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER:`Anna anomuksen numero, vähintään 4 merkkiä`,
    PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR:`anomushaussa on oltava vähintään 4 merkkiä`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR:`DTAC-tapauksen numeron haun on oltava täydellinen DTAC-tapausnumero, vähintään 4 merkkiä`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER:`Anna DTAC-tapauksen koko numero`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR:`Osanumerohaussa on oltava vähintään 4 merkkiä`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER:`Anna osanumero, vähintään 4 merkkiä`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR:`Varaosapyynnön numeron haussa on oltava vähintään 4 merkkiä`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER:`Anna varaosapyynnön numero, vähintään 4 merkkiä`,
    PART_REQUESTS_SEARCH_BY_PIN_ERROR:`PIN-haun on oltava vähintään 4 merkkiä pitkä`,
    PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER:`Anna PIN-koodi, vähintään 4 merkkiä`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR:`Työtilaushaun on oltava täysi työtilaus, vähintään kaksi merkkiä`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER:`Anna täysi työtilaus`,
    PART_REQUESTS_UPDATED_SUCCESSFULLY:`Varaosapyynnön päivitys onnistui`,
    PART_RETURN:`Varaosan palautus`,
    PART_RETURNS:`Varaosien palautukset`,
    PART_SERIAL_NUMBER:`Osan sarjanumero`,
    PART_SERIAL_NUMBER_IS_REQUIRED:`Osan sarjanumero vaaditaan`,
    PART_TOTAL:`Osa yhteensä`,
    PART_TYPE:`Varaosanumero`,
    PART_USE:`Osan käyttö`,
    PART_VALUE:`Osan arvo`,
    PARTIAL_DEBIT:`Osittainen debet`,
    PARTICIPANT:`Osallistuja`,
    PARTS:`Osat`,
    PARTS_ADDITIVE:`Osalisä`,
    PARTS_ADJUSTMENT:`Osien säätö`,
    PARTS_COVERAGE_SEARCH:`Osien peittohaku`,
    PARTS_TEMPLATE: `Osien malli`,
    PARTS_USE:`Osien käyttö`,
    PARTS_USE_IS_REQUIRED:`Osien käyttö on pakollista`,
    PARTS_WITH_COUNT:`Osat ({count})`,
    PARTS_WITH_PARENTHESES:`Osa(t)`,
    PAST_DUE:`Erääntynyt`,
    PAYER_ACCOUNT:`Maksajan tili`,
    PC_LIMIT:`Paalin raja`,
    PERCENT_COMPLETE:`Prosenttia valmiina`,
    PERCENTAGE:`Prosenttiosuus`,
    PERCENTAGE_DEBIT: `Debet-prosentti`,
    PERCENTAGE_SYMBOL:`{prosentti}`,
    PERCENTAGE_TO_DEBIT: `Veloitusprosentti`,
    PERMANENTLY_OUT_OF_SERVICE_MACHINES:`Pysyvästi poissa käytöstä olevat koneet`,
    PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT:`Jos koneita ei käytetä pysyvästi, lisää koneen kuva varmistaaksesi, ettei konetta voi rakentaa uudelleen, korjata tai käyttää missään vaiheessa tulevaisuudessa. Jatkuvasti poissa käytöstä olevat koneet eivät ole oikeutettuja PIP-ohjelmiin.`,
    PERSON_RESPONSIBLE:`Vastuuhenkilö`,
    PHONE:`Puhelin`,
    PHONE_REQUIRED: `Puhelin vaaditaan`,
    PICTURE:`Kuva`,
    PICTURE_REQUEST:`Kuvapyyntö`,
    PICTURE_REQUEST_STATUS:`Kuvapyynnön tila`,
    PICTURE_REQUEST_STATUS_ERROR:`Liitteet voidaan lähettää tämän pyynnön mukana.`,
    PIN:`PIN`,
    PIN_CREATED_SUCCESSFULLY:`PIN-koodin luonti onnistui`,
    PIN_CROSS_REFERENCE:`PIN-tunnuksen ristiviittaus`,
    PIN_INVALID:`PIN virheellinen`,
    PIN_IS_REQUIRED:`Tappi vaaditaan`,
    PIN_REQUIRED:`PIN vaaditaan`,
    PIN_SEARCH: `Kiinnitä haku`,
    PIN_SEARCH_INFORMATION: `Kiinnitä hakutiedot`,
    PIN_TRANSFER_INFORMATION: `Pin-siirtotiedot`,
    PINS:`PIN-koodit`,
    PINS_NOT_REGISTERED:`PIN-koodeja ei ole rekisteröity`,
    PIP:`PIP`,
    PIP_CODE:`PIP-koodi`,
    PIP_CODE_CREATED_SUCCESSFULLY:`PIP-koodipyynnön luonti onnistui`,
    PIP_CODE_REQUEST:`PIP-koodipyyntö`,
    PIP_CODE_REQUEST_APPROVED:`PIP-koodipyyntö hyväksytty`,
    PIP_CODE_REQUEST_REJECTED:`PIP-koodipyyntö hylätty`,
    PIP_CODE_REQUESTS_WITH_COUNT:`PIP-koodipyynnöt ({count})`,
    PIP_COMPLETION_STATUS:`PIP:n valmistumisen tila`,
    PIP_DETAILS:`PIP-tiedot`,
    PIP_HISTORY:`PIP-historia`,
    PIP_ID:`PIP-numero`,
    PIP_NUMBER:`PIP-numero`,
    PIP_PROGRAM:`PIP-ohjelma`,
    PIP_PROGRAM_IS_REQUIRED:`PIP-ohjelma vaaditaan`,
    PIP_PROGRAMS:`PIP-ohjelmat`,
    PIP_SEARCH:`PIP-haku`,
    PIP_STATUS:`PIP-tila`,
    PIP_TYPE:`PIP-tyyppi`,
    PIP_TYPES:`PIP-tyypit`,
    PIPS:`PIP-ohjelmat`,
    PIPS_UNPAID_LABOR_ADDITIVE:`PIP-ohjelmien palkaton työlisä`,
    PLAN_DESCRIPTION:`Suunnitelman kuvaus`,
    PLAN_END_DATE:`Suunnitelman päättymispäivä`,
    PLAN_ENDS:`Suunnitelman loppu`,
    PLAN_NAME:`Suunnitelman nimi`,
    PLAN_NAME_IS_REQUIRED:`Suunnitelman nimi vaaditaan`,
    PLAN_NAMES:`Suunnitelman nimet`,
    PLAN_START_DATE:`Suunnitelman alkamispäivämäärä`,
    PLAN_STARTS:`Suunnitelma alkaa`,
    PLANNED_BY:`Suunnitellut`,
    PLANT:`Kasvi`,
    PLATE_REQUEST_INFORMATION: `Kilven pyyntötiedot`,
    PLEASE_SELECT_A_LEAD_ACCOUNT:`Valitse liiditili`,
    PLEASE_SELECT_CLAIM_TYPE:`Valitse väitetyyppi`,
    POLISH:`puola`,
    PORTUGUESE:`portugali`,
    POSTAGE_DELIVERY_DATE:`Postittajan toimituspäivä`,
    POSTAL_CODE:`Postinumero`,
    POSTAL_CODE_REQUIRED: `Postinumero vaaditaan`,
    POSTAL_TRACKING_NUMBER:`Postituksen seurantanumero`,
    POTENTIAL_RESPONSIBLE_DEALER: `Mahdollinen vastuullinen jälleenmyyjä`,
    PRE_DELIVERY_INSPECTION:`Luovutustarkastus`,
    PREFERRED_THEME:`Ensisijainen teema`,
    PREPARE_AUDIT:`Valmistele tarkastus`,
    PREPARED:`Valmisteltu`,
    PREPARING_AUDIT_FOR_WITH_DEALER:`Valmistellaan {dealer}-tarkistusta`,
    PREVIOUS_AMOUNT_OF_USE:`Edellinen käyttömäärä`,
    PREVIOUS_INVOICE_NUMBER:`Edellinen laskun numero`,
    PREVIOUS_INVOICE_NUMBER_IS_REQUIRED:`Edellinen laskun numero on pakollinen`,
    PREVIOUS_MONTH:`Edellinen kuukausi`,
    PRICE:`Hinta`,
    PRICING_SUMMARY:`Hinnoitteluyhteenveto`,
    PRIMARY_ACTION:`Ensisijainen toiminto`,
    PRIMARY_LANGUAGE:`Ensisijainen kieli`,
    PRINT:`Tulosta`,
    PRINT_CLAIM:`Tulosta anomus`,
    PRINT_REGISTRATION_FORM:`Tulosta rekisteröintilomake`,
    PRINT_REGISTRATION_FORM_MESSAGE:`Tuote rekisteröity ensimmäiselle omistajalle. Haluatko tulostaa rekisteröintilomakkeen nyt?`,
    PRINT_TO_PDF:`Tulosta PDF-tiedostoon`,
    PRIORITY:`Prioriteetti`,
    PRNT_CLM:`Näytä anomus`,
    PROCESS_DATE:`Prosessin päivämäärä`,
    PROCESSED:`Käsitelty`,
    PROCESSED_PART_REQUESTS:`Käsitellyt osapyynnöt`,
    PROCESSING_STATUS:`Käsittelyn tila`,
    PROCESSING_STATUS_DESCRIPTION:`Käsittelyn tilan kuvaus`,
    PRODUCT_DETAILS:`Tuotteen tiedot`,
    PRODUCT_HIERARCHY: `Tuotehierarkia`,
    PRODUCT_INFORMATION:`Tuotetiedot`,
    PRODUCT_REGISTERED:`Tuote rekisteröity`,
    PRODUCT_REGISTRATION:`Tuotteen rekisteröinti`,
    PRODUCT_REGISTRATION_PENDED:`Tuotteen rekisteröinti on keskeytetty`,
    PRODUCT_TRACKING:`Tuoteseuranta`,
    PRODUCTS:`Tuotteet`,
    PRODUCTS_BY_CUSTOMER:`Tuotteet asiakkaan mukaan`,
    PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING:`Hakutuloksista saattaa puuttua aiempia PIN-koodeja tilapäisen järjestelmän yhteysongelman vuoksi`,
    PRODUCTS_WITH_COUNT:`Tuotteet ({count})`,
    PROGRAM:`Ohjelma`,
    PROGRAM_DESCRIPTION: `Ohjelman kuvaus`,
    PROGRAM_IS_REQUIRED:`Ohjelma on pakollinen.`,
    PROGRAM_NAME: `Ohjelman nimi`,
    PROGRAM_NUMBER:`Ohjelman numero`,
    PRT:`PRT`,
    PRTS:`PRT:t`,
    PURCHASE_INFO:`Ostotiedot`,
    PURCHASE_ORDER:`Ostotilaus`,
    PURCHASE_ORDER_IS_REQUIRED:`Ostotilaus on pakollinen`,
    PURCHASER_TYPE:`Ostajan tyyppi`,
    PURCHASER_TYPE_REQUIRED:`Ostajan tyyppi vaaditaan`,
    PUSH_XML:`Lähetä XML uudelleen`,
    QTY:`Määrä`,
    QUALIFY_FOR_EMISSIONS:`Päästöt`,
    QUANTITY:`Määrä`,
    QUANTITY_1:`Määrä 1`,
    QUANTITY_2:`Määrä 2`,
    QUANTITY_3:`Määrä 3`,
    QUANTITY_4:`Määrä 4`,
    QUANTITY_5:`Määrä 5`,
    QUANTITY_6:`Määrä 6`,
    QUANTITY_7:`Määrä 7`,
    QUANTITY_8:`Määrä 8`,
    QUANTITY_9:`Määrä 9`,
    QUANTITY_10:`Määrä 10`,
    QUERY_MUST_CONTAIN_3_CHARACTERS:`Kyselyssä on oltava vähintään kolme merkkiä`,
    QUEST_DESC: `Kyseltävä kuvaus`,
    QUESTIONABLE_PART: `Kyseltävä osa`,
    QUEUED: `Jonossa`,
    READING_DATE:`Lukupäivämäärä`,
    REASON: `Syy`,
    REASON_EVENT_NUMBER: `Tapahtuman syynumero`,
    REASON_FOR_CHANGE:`Muutoksen syy`,
    REASON_FOR_DEBIT:`Veloituksen syy`,
    REASON_FOR_MISSING_PLATE: `Puuttuvan levyn syy`,
    REASON_FOR_MISSING_PLATE_REQUIRED: `Puuttuvan levyn syy`,
    REASON_FOR_OVERRIDE:`Ohituksen syy`,
    REASON_FOR_REFUSAL:`Kieltäytymisen syy`,
    REASON_FOR_RETURN:`Palautuksen syy`,
    REASON_FOR_RETURN_IS_REQUIRED:`Palautuksen syy on pakollinen`,
    REASON_FOR_TRANSFER:`Siirron syy`,
    REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS:`Siirron syyssä on oltava aakkosnumeerisia merkkejä`,
    REASON_FOR_TRANSFER_REJECTION: `Siirron hylkäyksen syy`,
    RECIPIENT_DEALER_OR_TCSM: `Vastaanottaja(jälleenmyyjä tai TCSM)`,
    RECIPIENT_MAILING: `Postituksen vastaanottaja`,
    RECOMMENDATION: `Suositus`,
    RECOMMENDATION_DATE: `Suosituspäivämäärä`,
    RECOMMENDED_ACCOUNT: `Suositeltu tili`,
    RECONCILE:`Täsmäytä`,
    RECONCILE_CLAIM:`Täsmäytä anomus`,
    RECONCILED:`Täsmäytetty`,
    RECORD_AUDIT:`Tietueen seuranta`,
    RECORD_AUDIT_FOR:`Tietueen seuranta: {dealer}`,
    RECORDS_FOUND:`{countToDisplay} {count, monikko, löytyi yksi {record} muu {record}} muu`,
    RECOVERABLE_TAXES:`Palautettavat verot`,
    RECOVERED:`Palautettu`,
    RECOVERED_WITH_MISSED_ADDITIVES:`Palautettu puuttuvilla lisäilla`,
    RECOVERED_WITHOUT_ADDITIVES:`Peritty ilman lisiä`,
    RECOVERY:`Palautus`,
    RED_MUST_BE_LESS_THAN_YELLOW:`Punaisen Merkkivalon Arvon On Oltava Pienempi Kuin Keltainen Ilmaisin`,
    REFERENCE_1:`Viite 1`,
    REFERENCE_2:`Viite 2`,
    REFERENCE_INFORMATION:`Viitetiedot`,
    REFERENCE_NUMBER1:`Viitenumero 1`,
    REFERENCE_NUMBER2:`Viitenumero 2`,
    REGION:`Alue`,
    REGISTER:`Rekisteröi`,
    REGISTER_A_PRODUCT_BY_PIN:`Rekisteröi tuote PIN-tunnuksen mukaan`,
    REGISTER_A_PRODUCT_TO_ADD:`Rekisteröi takuujärjestelmään lisättävä tuote`,
    REGISTER_ANOTHER_PRODUCT:`Rekisteröi toinen tuote`,
    REGISTER_PRODUCT:`Rekisteröi tuote`,
    REGISTER_PRODUCT_AND_REGISTER_ANOTHER:`Rekisteröi tuote ja rekisteröi toinen`,
    REGISTERED:`Rekisteröity`,
    REGISTRATION:`Rekisteröinti`,
    REGISTRATION_DATE:`Rekisteröintipäivämäärä`,
    REGISTRATION_DATES:`Rekisteröintipäivämäärät`,
    REGISTRATION_FORM:`Rekisteröintilomake`,
    REGISTRATION_HISTORY:`Rekisteröintihistoria`,
    REGISTRATION_NOT_ALLOWED:`Rekisteröinti ei ole sallittu tälle tuotteelle`,
    REGISTRATION_REVIEW:`Rekisteröinnin tarkistus`,
    REGISTRATION_REVIEW_TAB:`Rekisteröinnin tarkistus ({count})`,
    REGISTRATION_STATUS:`Rekisteröinnin tila`,
    REGISTRATION_STATUS_CANNOT_BE_NEW:`Rekisteröinnin tila ei voi olla uusi`,
    REGISTRATION_STATUS_REQUIRED:`Rekisteröinnin tila vaaditaan`,
    REGISTRATION_SUCCESS:`Rekisteröinti onnistui`,
    REGISTRATION_TYPE:`Rekisteröintityyppi`,
    REGISTRATION_TYPE_CANNOT_BE_NEW:`Rekisteröintityyppi ei voi olla uusi`,
    REGISTRATION_TYPE_REQUIRED:`Rekisteröintityyppi vaaditaan`,
    REGISTRATION_UPDATED_SUCCESSFULLY: `Rekisteröinti päivitettiin onnistuneesti`,
    REGISTRATIONS_REVIEW:`Rekisteröintien tarkistus`,
    REIMBURSED:`Korvattu`,
    REIMBURSED_AMOUNT:`Hyvitetty summa`,
    REIMBURSED_PERCENTAGE:`Korvattu prosenttiosuus`,
    REIMBURSED_PERCENTAGE_INDICATOR:`Korvatun prosenttiosuuden ilmaisin`,
    REIMBURSEMENT_DETAILS:`Korvauksen tiedot`,
    REIMBURSEMENT_PERCENTAGE:`Korvausprosentti`,
    REIMBURSEMENT_SUMMARY:`Korvausten yhteenveto`,
    REJECT:`Hylkää`,
    REJECT_LABOR_RATE:`Hylkää työmäärä`,
    REJECT_SPECIAL_ALLOWANCE_CLAIM:`Hylkää erikoiskorvausanomus`,
    REJECTED:`Hylätty`,
    REJECTED_APPEAL:`Hylätty anomus`,
    RELATIONSHIP:`Suhde`,
    RELATIONSHIP_IS_REQUIRED:`Suhde on pakollinen`,
    REMOVE_FILTER:`Poista suodatin`,
    REMOVE_FROM_AUDIT:`Poista valvonnasta`,
    REMOVE_LAYOUT:`Poista asettelu`,
    RENTAL_PINS: `Vuokrauksen PIN-koodit`,
    REPAIR_DATE:`Korjauspäivämäärä`,
    REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE:`Korjauspäivämäärä ei voi olla ennen virhepäivää`,
    REPAIR_NUMBER:`Korjausnumero`,
    REPAIR_NUMBER_IS_REQUIRED:`Korjausnumero vaaditaan`,
    REPAIR_REPLACE_INDICATOR:`Korjaa/vaihda ilmaisin`,
    REPAIRED:`Korjattu`,
    REPAIRED_DATE:`Korjauspäivämäärä`,
    REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE:`Korjauspäivämäärä ei voi olla ennen epäonnistumispäivämäärää`,
    REPAIRED_DATE_IS_REQUIRED:`Korjauspäivämäärä on pakollinen`,
    REPORT_DATE:`Raportin päivämäärä`,
    REPORT_NUMBER:`Raportin numero`,
    REPORTS:`Raportit`,
    REQ_ADDL:`Säädä luottoa`,
    REQUEST: `Pyyntö`,
    REQUEST_DATE:`Pyynnön päivämäärä`,
    REQUEST_DETAILS:`Pyynnön tiedot`,
    REQUEST_DUPLICATE_PIN_PLATE: `Pyydä PIN-kortin kaksoiskappaletta`,
    REQUEST_FORM:`Pyyntölomake`,
    REQUEST_PIP_CODE:`Pyydä PIP-koodi`,
    REQUEST_STATUS:`Pyynnön tila`,
    REQUEST_SUBMITTED:`Pyyntö lähetetty`,
    REQUEST_TYPE:`Pyynnön tyyppi`,
    REQUEST_UPDATED_SUCCESSFULLY:`Pyyntö päivitettiin onnistuneesti`,
    REQUEST_WARRANTY_CLAIM_DEBIT:`Pyydä takuuanomuksen veloitusta`,
    REQUESTED:`Pyydetty`,
    REQUESTED_BY:`Pyytänyt`,
    REQUESTED_DATE:`Pyydetty päivämäärä`,
    REQUESTED_DATES:`Pyydetyt päivämäärät`,
    REQUESTED_DIAGNOSTIC_AMOUNT:`Pyydetty diagnostiikan summa`,
    REQUESTED_DIAGNOSTIC_HOURS:`Pyydetyt diagnostiikkatunnit`,
    REQUESTED_LABOR_AMOUNT:`Pyydetty työsumma`,
    REQUESTED_LABOR_HOURS:`Pyydetyt työtunnit`,
    REQUESTED_OTHER_CREDITS:`Pyydetyt muut hyvitykset`,
    REQUESTED_PARTS:`Pyydetyt osat`,
    REQUESTED_REPAIR_AMOUNT:`Pyydetty korjaussumma`,
    REQUESTED_REPAIR_HOURS:`Pyydetyt korjaustunnit`,
    REQUESTED_TRAVEL_TOTAL:`Pyydetty matka yhteensä`,
    REQUESTER_TCSM: `Pyytäjä (TCSM)`,
    REQUESTER_TCSM_REQUIRED: `Pyytäjä(TCSM) vaaditaan`,
    REQUIRED:`pakollinen`,
    REQUIRED_CRITERIA:`Pakolliset ehdot`,
    REQUIRED_ITEMS:`Pakolliset kohteet`,
    RESEND_XML:`Lähetä XML uudelleen`,
    RESET:`Palauta`,
    RESPONDENT_INFORMATION:`Vastaajan tiedot`,
    RESPONSIBILITY_OF:`Vastuu`,
    RESPONSIBLE_ACCOUNT:`Vastaava tili`,
    RESPONSIBLE_ACCOUNT_IS_REQUIRED:`Vastuutili on pakollinen`,
    RESPONSIBLE_DEALER:`Vastuussa oleva jälleenmyyjä`,
    RESPONSIBLE_DEALER_REPORT_RECORDS_COUNT_WARNING: `Näytetään ensimmäiset 100 tulosta. Lataa täydelliset tulokset`,
    RET:`Paluu`,
    RETAIL_INSTALL:`Vähittäismyynti/asennus`,
    RETAIL_INSTALL_DATE:`Vähittäismyynnin/asennuksen päivämäärä`,
    RETAIL_INSTALL_IS_REQUIRED:`Vähittäismyynti/asennus on pakollinen`,
    RETAILER_NAME:`Vähittäismyyjän nimi`,
    RETAILER_NAME_IS_REQUIRED:`Vähittäismyyjän nimi vaaditaan`,
    RETRY: `yritä uudelleen`,
    RETURN:`Paluu`,
    RETURN_LABOR_RATE: `Palautustyömäärä`,
    RETURN_REQUEST:`Palautuspyyntö`,
    RETURN_SPECIAL_ALLOWANCE_CLAIM:`Erikoiskorvausanomus`,
    RETURN_STATUS:`Palautustila`,
    RETURNED:`Palautettu`,
    RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE:`Palautuspäivämäärä ei voi olla ennen toimituspäivää`,
    RETURNED_DATE_IS_REQUIRED:`Palautuspäivämäärä on pakollinen`,
    RETURNED_MACHINE_STATUS_UPDATE: `Palautetun koneen tilan päivitys`,
    REVIEW_DEALER_RECOMMENDATIONS: `Haluatko varmasti merkitä PIN-koodit tarkistusta varten?`,
    REVISE:`Muuta`,
    REVISED:`Tarkistettu`,
    ROLLING_12_CREDIT_AMOUNT:`Vierivä 12 kredit-summa`,
    ROLLING_12_MONTHS:`12 kuukautta`,
    RUN_REPORT:`Suorita raportti`,
    RUSSIAN:`venäjä`,
    SAP_DOWN_WARNING:`Takuujärjestelmän toiminta on rajoittunut. Pyrimme korjaamaan asian mahdollisimman nopeasti. Tarkista järjestelmän käytettävyys päivittämällä selain.`,
    SAVE:`Tallenna`,
    SAVE_AS_DRAFT:`Tallenna luonnoksena`,
    SAVE_AS_NEW_LAYOUT:`Tallenna uutena asetteluna`,
    SAVE_AUDIT:`Tallenna seuranta`,
    SAVE_CHANGES:`Tallenna muutokset`,
    SAVE_TO_VALIDATE:`Tallenna vahvistettavaksi`,
    SAVE_VALD:`Tallenna ja vahvista`,
    SAVE_VALIDATE:`Tallenna ja vahvista`,
    SEARCH:`Etsi`,
    SEARCH_BOX_PLACEHOLDER:`Anna PIN, sarjanumero, takuuhakemuksen numero, DTAC-tapaus tai asiakkaan nimi`,
    SEARCH_BY_CLAIM_TYPE:`Anna koko anomuksen tyyppi`,
    SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL:`anomushaun on oltava koko väitetyypin mukainen, 4-9 merkkiä`,
    SEARCH_BY_FAILURE_PART_NUMBER:`Anna vikakoodin koko numero`,
    SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL:`anomushaun on oltava osanumeron täysi virhe, vähintään 4 merkkiä`,
    SEARCH_BY_WORK_ORDER:`Anna työtilaus, vähintään 2 merkkiä`,
    SEARCH_BY_WORK_ORDER_VALIDATION_FAIL:`Työtilaushaussa on oltava vähintään kaksi merkkiä`,
    SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER:`Anna koko takuuhakemuksen numero`,
    SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL:`anomushaun on oltava koko anomusnumeron tasolla 4-9 merkkiä`,
    SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER:`Anna koko osan sarjanumero`,
    SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL:`Komponenttihaun on oltava täydellinen sarjanumero, vähintään 1 merkki`,
    SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER:`Anna PIN`,
    SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER:`Anna koko mallinumero`,
    SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL:`Mallihaun on oltava täydellinen mallinumero, 3-12 merkkiä`,
    SEARCH_PRODUCT_BY_PIN_PLACEHOLDER:`Anna PIN-koodi, vähintään 6 merkkiä`,
    SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL:`PIN-haussa on oltava 6-17 merkkiä`,
    SEARCH_PRODUCT_BY_PIP_PLACEHOLDER:`Anna PIP-numero, vähintään 4 merkkiä`,
    SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL:`PIP-haussa on oltava 4-12 merkkiä`,
    SEARCH_RESULTS_TAB:`Hakutulokset ({count})`,
    SECOND_SHIP_TO_LOCATION:`Toinen toimituspaikka`,
    SELECT:`Valitse`,
    SELECT_A_RANGE:`Valitse alue`,
    SELECT_ALL:`Valitse kaikki`,
    SELECT_AUTO_SUBMIT:`Valitse Automaattinen lähetys`,
    SELECT_BRANCH:`Valitse haara`,
    SELECT_CLAIM_TYPE:`Valitse takuuhakemuksen tyyppi`,
    SELECT_CLAIMS:`Valitse takuuhakemukset`,
    SELECT_CLAIMS_WITHIN_DATE_RANGE:`Valitse takuuhakemukset päivämäärävälillä`,
    SELECT_COLUMNS:`Valitse sarakkeet`,
    SELECT_COUNTRY:`Valitse maa`,
    SELECT_CSV_SEPARATOR:`Valitse CSV-erotin`,
    SELECT_DATE_FORMAT:`Valitse päivämäärän muoto`,
    SELECT_DEALERS_AND_STATUS:`Valitse jälleenmyyjät ja tila`,
    SELECT_DECIMAL_FORMAT:`Valitse desimaalimuoto`,
    SELECT_DISPLAY_FORMAT:`Valitse näyttömuoto`,
    SELECT_FACTORY:`Valitse tehdas`,
    SELECT_LANGUAGE:`Valitse kieli`,
    SELECT_LAYOUT:`Valitse asettelu`,
    SELECT_NEW_CLAIMS:`Valitse uudet takuuhakemukset`,
    SELECT_PIP_CODE:`Valitse PIP-koodi`,
    SELECT_PLAN_NAMES:`Valitse suunnitelman nimet`,
    SELECT_SERVICE_INTERVAL_TYPES:`Valitse huoltovälityypit`,
    SELECT_SORT_BY:`Valitse lajitteluperuste`,
    SELECT_SORT_DIRECTION:`Valitse lajittelusuunta`,
    SELECT_STATE:`Valitse tila`,
    SELECT_STATUS:`Valitse tila`,
    SELECT_TERRITORY:`Valitse alue`,
    SELECT_THEME:`Valitse teema`,
    SELECT_TIME_ZONE:`Valitse aikavyöhyke`,
    SELECT_VALUES_TO_APPROVE:`Valitse Hyväksyttävät arvot`,
    SELECTED_COLUMNS:`Valitut sarakkeet`,
    SELECTED_FOR_AUDIT: `Valittu tarkastusta varten`,
    SELECTED_FOR_AUDIT_VSR: `Katso DTAC-ratkaisusta 221475 tämän väitteen edellyttämät tarkistusasiakirjat ja -liitteet`,
    SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE:`Useiden tilien ja takuutyyppien valitseminen vaikuttaa suorituskykyyn`,
    SEND:`Lähetä`,
    SERIAL_NUMBER:`Sarjanumero`,
    SERIAL_NUMBER_INVOICE_NUMBER:`Sarjanumero / laskun numero`,
    SERVER_TOOK_TOO_LONG_TO_REPLY:`Palvelin vastasi liian kauan, ja pyyntö on peruutettu. Yritä tarkemmin tai yritä myöhemmin uudelleen.`,
    SERVICE_DATE_IS_REQUIRED:`Huoltopäivämäärä on pakollinen`,
    SERVICE_INTERVAL:`Huoltoväli`,
    SERVICE_INTERVAL_BEGIN_DATE:`Huoltovälin aloituspäivämäärä`,
    SERVICE_INTERVAL_END_DATE:`Huoltovälin päättymispäivä`,
    SERVICE_INTERVAL_IS_REQUIRED:`Huoltoväli on pakollinen`,
    SERVICE_INTERVAL_NUMBER:`Huoltovälin numero`,
    SERVICE_INTERVAL_STATUS:`Huoltovälin tila`,
    SERVICE_INTERVAL_TYPE:`Huoltovälin tyyppi`,
    SERVICE_INTERVAL_TYPES:`Huoltovälityypit`,
    SERVICE_PART:`Huolto-osa`,
    SERVICE_UNAVAILABLE:`Palvelu ei ole käytettävissä`,
    SERVICED:`Huollettu`,
    SERVICED_DATE_IS_REQUIRED:`Huoltopäivämäärä on pakollinen`,
    SERVICED_IS_REQUIRED:`Huolto on tarpeen.`,
    SET_AS_DEFAULT:`Aseta oletukseksi`,
    SETTINGS:`Omat asetukset`,
    SETTLED:`Selvitetty`,
    SETTLEMENT_NO_REGISTRATION:`Tilitys, ei rekisteröintiä`,
    SETUP:`Asetukset`,
    SETUP_DATE_IS_REQUIRED:`Asetuspäivämäärä on pakollinen`,
    SETUP_IS_REQUIRED:`Asetukset ovat pakollisia`,
    SGST_UTGST:`SGST/UTGST`,
    SHIP_TO:`Toimitusosoite`,
    SHIPPED:`Lähetetty`,
    SHIPPING_ID: `Lähetystunnus`,
    SHIPPING_ID_REQUIRED: `Kuljetustunnus vaaditaan`,
    SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: `Lähetystiedot/erityisohjeet`,
    SHIPPING_INSTRUCTIONS:`Toimitusohjeet`,
    SHORT_TEXT:`Lyhyt teksti`,
    SHORT_TEXT_IS_REQUIRED:`Lyhyt teksti vaaditaan`,
    SHOW_ALL:`Näytä kaikki ({count})`,
    SHOW_EXCLUDED:`Näytä ohitetut`,
    SHOW_MORE:`Näytä lisää`,
    SHOW_MORE_GROUPS:`Näytä {countToDisplay} muuta {count, monikko, yksi {group} muu {group}}`,
    SHOW_RED_IF_LESS_THAN:`Näytä punainen, jos pienempi kuin`,
    SHOW_REIMBURSED_AMOUNT:`Näytä hyvitetty summa`,
    SHOW_REIMBURSED_PERCENTAGE:`Näytä hyvitetty prosentti`,
    SHOW_YELLOW_IF_LESS_THAN:`Näytä keltainen, jos pienempi kuin`,
    SIGN_IN_REQUIRED: `Kirjaudu sisään`,
    SIGN_OUT:`Kirjaudu ulos`,
    SKIP_AUDIT:`Ohita seuranta`,
    SKIP_AUDIT_SUCCESS:`Tarkastus on ohitettu, ja määräpäivä on nyt tulevaisuudessa.`,
    SOME_PARTS_RETURNED:`Joitakin osia palautettu`,
    SORT_BY:`Lajitteluperuste`,
    SPANISH:`espanja`,
    SPECIAL_ALLOWANCE:`Erikoisavustus`,
    SPECIAL_ALLOWANCE_CALCULATION:`Erikoisavustuksen laskenta`,
    SPECIAL_ALLOWANCE_CLAIM:`Erikoiskorvausanomus`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS:`Erikoiskorvausanomuksen tila`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM:`Erikoiskorvausanomuksen tila`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED:`Erikoiskorvausanomuksen tila päivitetty`,
    SPECIAL_ALLOWANCE_CLAIM_WITH_ID:`Erikoiskorvausanomus - {claimNumber}`,
    SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT:`Erikoiskorvausanomukset ({count})`,
    SPECIAL_ALLOWANCE_CONTRIBUTIONS:`Erikoisavustukset`,
    SPECIAL_ALLOWANCE_DESCRIPTION:`Erikoisavustuksen kuvaus`,
    SPECIAL_ALLOWANCE_TYPE:`Erikoisavustuksen tyyppi`,
    SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED:`Erikoisavustuksen tyyppi vaaditaan`,
    SPECIAL_INSTRUCTIONS:`Erityisohjeet`,
    SPG:`SPG`,
    SPGS:`SPG:t`,
    STANDARD_VIEW:`Vakionäkymä`,
    START_AMOUNT_OF_USE:`Aloitusmäärä`,
    STARTS:`Alkaa`,
    STARTS_WITH:`Alkaa`,
    STATE:`Osavaltio`,
    STATE_PROVINCE: `Osavaltio/provinssi`,
    STATE_PROVINCE_REQUIRED: `Vaadittu osavaltio/provinssi`,
    STATUS:`Tila`,
    STATUS_CHANGE_REQUEST:`Tilamuutospyyntö`,
    STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY:`Tilamuutospyynnön luonti onnistui`,
    STATUS_CHANGE_REQUEST_UPDATED_SUCCESSFULLY:`Koneen tilapyynnön päivitys onnistui`,
    STATUS_FOR:`Tila: {pin}`,
    STATUS_INDICATOR:`Tilailmaisin`,
    STATUS_REASON:`Tilan syy`,
    STOLEN_DATE:`Varastettu päivämäärä`,
    STORE:`Myymälä`,
    STORE_IS_REQUIRED:`Myymälä on pakollinen`,
    STORE_NUMBER_IS_REQUIRED:`Myymälän numero on pakollinen`,
    STREET_1:`Katuosoite 1`,
    STREET_2:`Katuosoite 2`,
    SUB:`Lähetä`,
    SUB_CLAIM_TYPE:`Alianomuksen tyyppi`,
    SUB_TYPE:`Alityyppi`,
    SUBMISSION_DATE:`Lähetyspäivämäärä`,
    SUBMIT:`Lähetä`,
    SUBMIT_AUDIT:`Lähetä seuranta`,
    SUBMIT_AUDIT_FOR:`Lähetä {dealer}-seuranta`,
    SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER:`Lähetä {claimNumber} täysimittainen veloitusanomus`,
    SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER:`Lähetä osaveloitusanomus mallille {claimNumber}`,
    SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER:`Lähetä prosentin debet-vaatimus kohteelle {claimNumber}`,
    SUBMIT_REQUEST:`Lähetä pyyntö`,
    SUBMITTED:`Lähetetty`,
    SUBMITTED_AVAILABLE_TO_EDIT:`Lähetetty (muokattava)`,
    SUCCESS: `Onnistui`,
    SUCCESS_MESSAGE_TITLE:`Toiminto onnistui:`,
    SUCCESS_MESSAGES_TITLE:`Useita toimintoja onnistui:`,
    SUPPLIER_WARRANTY:`Toimittajan takuu`,
    SURVEY_QUESTIONS:`Kyselykysymykset`,
    SUSPENDED:`Keskeytetty`,
    SWEDISH: `Ruotsi`,
    SYSTEM_SELECTED_CLAIMS:`Järjestelmän valitsemat väitteet`,
    SYSTEM_SELECTED_CLAIMS_WITH_COUNT:`Järjestelmän valitsemat väitteet ({count})`,
    TABM:`TABM`,
    TAX:`Vero`,
    TCSM:`TCSM`,
    TCSM_COMMENTS: `TCSM-kommentit`,
    TCSM_ID: `TCSM-tunnus`,
    TECH_ID:`Tekniikan tunnus`,
    TERMINATED:`Päätetty`,
    TERMINATES:`Päättyy`,
    TERRITORY:`Alue`,
    TEST:`Testi`,
    TEST_RESULTS_CODE:`Testitulosten koodi`,
    THEME:`Teema`,
    TIME_LIMIT:`Aikaraja`,
    TIME_ZONE:`Aikavyöhyke`,
    TITLE:`Otsikko`,
    TITLE_IS_REQUIRED:`Otsikko on pakollinen`,
    TO:`Vastaanottaja`,
    TODAY:`Tänään`,
    TOO_MANY_RESULTS: `Pyyntösi palautti liian monta tulosta. Tarkenna hakuehtoja ja yritä uudelleen.`,
    TOTAL:`Yhteensä`,
    TOTAL_AMOUNT:`Kokonaissumma`,
    TOTAL_AMOUNT_IN_LOCAL_CURRENCY: `Yhteensä PLN`,
    TOTAL_APPROVED:`Hyväksytty yhteensä`,
    TOTAL_APPROVED_CLAIM_VALUE:`Hyväksytyn anomuksen kokonaisarvo`,
    TOTAL_APPROVED_INCLUDING_TAXES:`Hyväksytty yhteensä, sisältää verot`,
    TOTAL_APPROVED_WITHOUT_ADDITIVES:`Hyväksytty yhteensä ilman lisiä`,
    TOTAL_CONTRIBUTION:`Kokonaisosuus`,
    TOTAL_REIMBURSED:`Hyvitetty yhteensä`,
    TOTAL_REIMBURSED_WITH_CURRENCY:`Hyvitetty yhteensä ({valuutta})`,
    TOTAL_REQUESTED:`Pyydetty yhteensä`,
    TOTAL_REQUESTED_CLAIM_VALUE:`Pyydetyn anomuksen kokonaisarvo`,
    TOTAL_UNPAID:`Maksamattomat yhteensä`,
    TRACKING_NUMBER:`Seurantanumero`,
    TRANSFER:`Siirto`,
    TRANSFER_ALL: `Siirrä kaikki`,
    TRANSFER_APPROVALS:`Siirrä hyväksynnät`,
    TRANSFER_APPROVALS_TAB:`Siirrä hyväksynnät ({count})`,
    TRANSFER_CREATED:`Siirto luotu`,
    TRANSFER_DEALER_RECOMMENDATIONS: `Siirrä jälleenmyyjäsuositukset`,
    TRANSFER_REJECTED: `Siirto hylätty`,
    TRANSFER_UPDATED_SUCCESSFULLY:`Siirto päivitettiin`,
    TRANSFERALL_DEALER_RECOMMENDATIONS: `Siirrä kaikki jälleenmyyjäsuositukset`,
    TRANSFERS:`Siirrot`,
    TRAVEL:`Matka`,
    TURKISH:`turkki`,
    TWO_PERCENT_WITHHOLD_VALUE:`Pidätysarvo 2 %`,
    TYPE:`Tyyppi`,
    TYPES:`Tyypit`,
    UNABLE_TO_CONTACT_THE_SERVER:`Palvelimeen ei saada yhteyttä`,
    UNABLE_TO_COPY_ATTACHMENTS: `Liitteiden kopioiminen alkuperäisestä vaatimuksesta ei onnistunut. Tarkista asia ennen uuden vaatimuksen lähettämistä.`,
    UNABLE_TO_LOAD_CUSTOMER_DETAILS:`Asiakkaan tietoja ei voi ladata`,
    UNDO: `Kumoa`,
    UNDO_REGISTRATION: `Kumoa rekisteröinti`,
    UNDO_REGISTRATION_SUCCESSFULL: `Rekisteröinnin kumoaminen onnistui`,
    UNIT:`Yksikkö`,
    UNIT_1:`Yksikkö 1`,
    UNIT_2:`Yksikkö 2`,
    UNIT_3:`Yksikkö 3`,
    UNIT_OF_MEASURE:`Mittayksikkö`,
    UNPAID_LABOR:`Palkaton työ`,
    UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS:`Unpaid Labor Additives (Maksamattomat töiden lisäkorvaukset - PIP-korjaukset pois lukien)`,
    UNPAID_LABOR_ADDITIVES_PIPS:`Unpaid Labor Additives - PIPs (Maksamattomat töiden lisäkorvaukset - PIP-korjaukset)`,
    UNPAID_OTHER_CREDITS:`Maksamattomat muut hyvitykset`,
    UNPAID_PARTS:`Maksamattomat osat`,
    UNPAID_PARTS_ADDITIVE:`Maksamattomien osien lisä`,
    UNPAID_TRAVEL:`Maksamaton matka`,
    UNRECONCIL: `Täsmäytyksen poisto`,
    UNRECONCILE_CLAIM : `Täsmäytä vaatimus`,
    UNSUB:`Peruuta lähetys`,
    UNSUBMIT_CLAIM:`Peruuta anomus`,
    UPDATE: `Päivitä`,
    UPDATE_CUSTOMER_INFORMATION:`Päivitä asiakastiedot`,
    UPDATE_LABOR_RATES:`Päivitä työasteet`,
    UPDATE_LAYOUT:`Päivitä asettelu`,
    UPDATE_MACHINE_STATUS:`Päivitä koneen tila`,
    UPDATE_MACHINE_STATUS_HISTORY:`Päivitä koneen tilahistoria`,
    UPDATE_REGISTRATION: `Päivitä rekisteröinti`,
    UPDATE_SELECTED:`Päivitä valitut`,
    UPDATED:`Päivitetty`,
    UPDATED_BY:`Päivittänyt`,
    UPDATED_DATE_FROM:`Päivityspäivämäärästä`,
    UPDATED_DATE_TO:`Päivityspäivään`,
    UPLOAD_DOCUMENT:`Lataa tiedosto`,
    UPTIME_ASSURANCE:`Käyttöajan valvonta`,
    USEFUL_LINKS:`Hyödyllisiä linkkejä`,
    USER: `käyttäjä`,
    USER_PREFERENCES_UPDATED:`Käyttäjäasetukset päivitetty`,
    USER_SELECTED:`Käyttäjä valittu`,
    USER_SELECTED_CLAIMS_WITH_COUNT:`Käyttäjän valitsemat väitteet ({count})`,
    USERS_INFORMATION: `Käyttäjien tiedot`,
    VALIDATE:`Vahvista`,
    VALIDATE_CLAIM:`Vahvista anomus`,
    VALUE:`Arvo`,
    VALUE_OF_REPAIR:`Korjausarvo`,
    VIEW_CLAIM:`Näytä anomus`,
    VIEW_DETAILS:`Näytä tiedot`,
    VIEW_OPEN_PIPS:`Näytä avoimet PIP-ohjelmat`,
    VIEW_PIP:`Näytä PIP`,
    VIEW_PRODUCTS: `Näytä tuotteet`,
    VIEW_PRODUCTS_AND_UPDATE_INFO:`Näytä tuotteet ja päivitä tiedot`,
    VIEW_UPDATE:`Näytä/päivitä`,
    VSR_MESSAGES:`VSR-viestit`,
    WAITING_FOR_DLR_INV:`Odotetaan Jälleenmyyjän Laskua`,
    WAITING_FOR_INVOICE:`Odotetaan laskua ({count})`,
    WAITING_SINCE:`Odotetaan`,
    WARNING_MESSAGE_TITLE:`Varoitus lähetettiin:`,
    WARNING_MESSAGES:`Varoitusviestit`,
    WARNING_MESSAGES_TITLE:`Useita varoituksia lähetettiin:`,
    WARRANTY:`Takuu`,
    WARRANTY_ADMIN:`Takuun järjestelmänvalvoja`,
    WARRANTY_CLAIM_TYPE: `Takuuvaatimuksen tyyppi`,
    WARRANTY_COVERAGE:`Takuun kattavuus`,
    WARRANTY_EXPIRATION:`Takuun vanhentuminen`,
    WARRANTY_TYPE:`Takuun tyyppi`,
    WARRANTY_TYPES:`Takuutyypit`,
    WEAR_PARTS:`Kulutusosat`,
    WEAR_PARTS_COVERAGE:`Kulutusosat`,
    WELCOME:`Tervetuloa`,
    WINTERIZATION: `Talvisäilytys`,
    WIP:`Työ käynnissä`,
    WITH_ADDITIVES:`Lisien kanssa`,
    WITNESS_FIRST_NAME:`Todistajan etunimi`,
    WITNESS_LAST_NAME:`Todistajan sukunimi`,
    WORK_ORDER:`Työjärjestys`,
    WORK_ORDER_NUMBER:`Työtilauksen numero`,
    WORK_ORDER_ONE:`Työtilaus 1`,
    WORK_ORDER_ONE_IS_REQUIRED:`Työtilaus 1 vaaditaan`,
    WORK_ORDER_THREE:`Työtilaus 3`,
    WORK_ORDER_THREE_IS_REQUIRED:`Työtilaus 3 vaaditaan`,
    WORK_ORDER_TWO:`Työtilaus 2`,
    WORK_REPAIR_ORDER:`Työkorjaustilaus`,
    YES:`KYLLÄ`,
    YES_LOWERCASE:`Kyllä`
});



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-i18n/lib/fi.js